import { OPEN_STATUS } from "@/enums/open-status-type";
import {
  FACILITY_STATUS,
  BING_FACILITY_STATUS
} from "@/enums/facility-status-type";
import { WEEK_DAYS } from "@/enums/week-days";
import {
  POST_TYPE,
  POSTS_FORM_TYPE,
  POSTS_CALL_TO_ACTION_TYPE,
  POST_BY_FACILITY_STATUS
} from "@/enums/posts.enum";
import { FACILITY_CREATE_ACTION } from "@/enums/gmb-search-type";
import { FACILITIES_SORTING_OPTION } from "@/enums/facilities-sorting-option";
import {
  PERIODIC_REPORT_TYPE,
  TOP_CHART_SERIE
} from "@/enums/charts-type.enum";
import { AccountType } from "@/enums/account-type";

import {
  EXTERNAL_CHANGES_SOURCE,
  EXTERNAL_CHANGES_TYPE,
  EXTERNAL_CHANGES_STATUS,
  EXTERNAL_CHANGES_FIELD
} from "@/enums/external-changes";
import { KEYWORDS_SCOPE } from "@/enums/keywords";
import { DIALOG_MANAGE_MODE } from "@/enums/reply-templates";
import { REVIEWS_TAGS_SEARCH_TYPE } from "@/enums/reviews.enum";
import { Module } from "@/enums/modules";
import { GMB_MEDIA_STATUS } from "@/enums/gmb-media-status";
import { GMB_MEDIA_TYPE } from "@/enums/gmb-media-type";

//messages.js
export default {
  common: {
    showMore: "Pokaż więcej",
    showLess: "Pokaż mniej",
    setPasswordAndFinishRegistration: "Ustaw hasło i dokończ rejestrację",
    expand: "Rozwiń",
    areas: "Obszary",
    areaFacility: "Wizytówka obszarowa",
    areaFacilityTooltip:
      "Nie można wybrać tej wizytówki, ponieważ jest to wizytówka obszarowa. Dla wizytówek obszarowych pozycje w wynikach wyszukiwania nie są monitorowane.",
    readMore: "Czytaj więcej",
    page: "Strona {0}",
    collapse: "Zwiń",
    copyAddress: "Skopiuj adres",
    locations: "Wizytówki",
    members: "Użytkownicy",
    keywords: "Słowa kluczowe",
    tags: "Kategorie opinii",
    competitors: "Wizytówki konkurencji",
    yourFacility: "Twoja wizytówka",
    competitorsFacility: "Wizytówka konkurencji",
    deleteSelected: "Usuń zaznaczone",
    learnMore: "Dowiedz się",
    name: "Nazwa",
    stats: "Statystyki",
    videoTutorialsTooltip: "Obejrzyj nagranie prezentujące tą funkcjonalność.",
    faq: "Pomoc",
    edited: "Edytowano",
    selectImportColumns: "Wybierz kolumny, które chcesz zaimportować",
    upload: "Prześlij",
    addFile: "Dodaj plik",
    groups: "Grupy",
    exportToCSV: "Eksportuj do CSV",
    exportCSV: "Eksportuj CSV",
    exportToFile: "Eksportuj do pliku",
    downloadStarted: "Pobieranie rozpoczęte",
    desktop: "desktop",
    mobile: "mobile",
    show: "Pokaż {0}",
    select: "Wybierz",
    range: "Promień",
    selectAddress: "Wybierz adres",
    undo: "Cofnij",
    bestPractices: "Dobre praktyki",
    above: "Powyżej",
    hour: "Godzina",
    date: "Data",
    dontShowItAgain: "Nie pokazuj tego więcej",
    dataProcessing:
      "Kategoria w trakcie przetwarzania. System szuka obecnie opinii pasujących do tej kategorii. Do końca przetwarzania nie możesz wprowadzić nowych zmian.",
    allReviews: "Wszystkie opinie",
    reviewsWithoutCategory: "Opinie bez kategorii",
    changeName: "Zmień nazwę",
    accept: "Akceptuj",
    accessibility: "Ułatwienia dostępu",
    accountData: "Dane konta",
    accountSettings: "Ustawienia konta",
    accountAdded: "Konto dodane",
    accountDeleted: "Konto usunięte",
    accountType: "Rodzaj konta",
    actions: "Akcje",
    addDomain: "Wpisz domenę",
    add: "Dodaj",
    points: "pkt",
    addAccount: "Dodaj konto",
    addBusinessAddress: "Dodaj wizytówkę",
    addFacility: "Dodaj wizytówkę",
    addFbId: "Dodaj page ID",
    addManually: "Wprowadź samodzielnie",
    addMonitoredKeywords: "Dodaj hasła do monitorowania",
    addNew: "Dodaj nowy",
    addNewTerm: "Dodaj nowe hasło",
    addOwnBusinessAddress: "Dodaj swoją wizytówkę",
    addProfile: "Dodaj profil",
    addProfileName: "Dodaj nazwę profilu",
    address: "Adres",
    additionalCategories: "Dodatkowe kategorie działalności",
    addUrlAddress: "Podaj adres URL",
    urlAddress: "Adres URL",
    after: "Po",
    analytics: "Analiza",
    comparator: "Porównaj wizytówki",
    apply: "Zastosuj",
    appliance: "Urządzenie",
    all: "Wszystko",
    allFacilities: "Wszystkie wizytówki",
    more: "Więcej",
    less: "Mniej",
    added: "Dodano",
    assignAccount: "Przypisz konto",
    avg_rate_on_main_page: "Średnia ocena z najtrafniejszych komentarzy",
    accurate_number_of_photos: "Zdjecia",
    ascending: "Rosnąco",
    automatically: "Automatycznie",
    back: "Wstecz",
    backToList: "Powrót do listy",
    backToSignIn: "Powrót do logowania",
    before: "Przed",
    businessAddress: "Adres firmy",
    businessAddresses: "Wizytówki",
    businessAddressesGroups: "Grupy wizytówek",
    businessAddressesList: "Lista wizytówek",
    businessAddressOrWww: "Wizytówka lub strona www",
    billingData: "Dane do fakturowania",
    by: "przez",
    cancel: "Anuluj",
    categories: "Kategorie",
    category: "Kategoria",
    change: "Zmień",
    changeAccountType: "Zmiana rodzaju konta",
    changeSinceLastWeek: "Zmiana od ostatniego tygodnia",
    choose: "Wybierz",
    chooseDate: "Wybierz datę",
    chooseGmbAccount: "Wybierz konto Google",
    choosePeriod: "Wybierz zakres",
    chooseProfile: "Wybierz profil",
    chosenBusinessAddress: "Wybrana wizytówka",
    city: "Miasto",
    clear: "Wyczyść",
    clients_activity_score: "Aktywność klientów",
    close: "Zamknij",
    closed: "Zamknięte",
    collectData: "Zbieramy dane",
    companyName: "Nazwa firmy w panelu Center AI",
    legalCompanyName: "Nazwa firmy",
    taxNumber: "NIP",
    companyProfile: "Ustawienia",
    compareWith: "Porównaj z",
    competition: "Konkurencja",
    competitionVisibility: "Porównanie z konkurencją",
    competitiveBusinessAddresses: "Konkurencyjne wizytówki",
    competitiveWebsites: "Konkurencyjne strony www",
    confirm: "Potwierdź",
    confirmDelete: "Tak, usuń",
    confirmPassword: "Potwierdź hasło",
    consentsAndRegulations: "Zgody i regulamin",
    contact: "Kontakt",
    contactPhone: "Telefon kontaktowy",
    contactWithUs: "Skontaktuj się z nami",
    content: "Zawartość",
    continue: "Kontynuuj",
    country: "Kraj",
    cover_photo: "Zdjęcie w tle",
    createAccount: "Załóż konto",
    createBusinessAddress: "Utwórz wizytówkę",
    currentData: "Aktualne dane",
    dashboard: "Pulpit",
    day: "Dzień",
    dateFrom: "Data od",
    dateTo: "Data do",
    dateRange: "Zakres dat",
    delete: "Usuń",
    deletePicked: "Odłącz zaznaczone",
    descending: "Malejąco",
    description: "Opis",
    details: "Szczegóły",
    seeDetails: "Zobacz szczegóły",
    direction: "Kierunek",
    doYouWantToSaveChanges: "Czy chcesz zapisać zmiany?",
    monday: "Poniedziałek",
    tuesday: "Wtorek",
    wednesday: "Środa",
    thursday: "Czwartek",
    friday: "Piątek",
    saturday: "Sobota",
    sunday: "Niedziela",
    edit: "Edytuj",
    editFromFile: "Edytuj z pliku",
    editData: "Edytuj dane",
    email: "E-mail",
    emailAddress: "Adres e-mail",
    exportTo: "Eksportuj do:",
    exportData: "Eksportuj dane",
    exportSelect: "Eksportuj do",
    exportTo2: "Eksportuj do",
    exportGroupedByDates: "z podziałem na daty",
    exportGroupedByLocations: "z podziałem na wizytówki",
    facility: "Wizytówka",
    facilityData: "Dane wizytówki",
    facilityName: "Nazwa wizytówki",
    fillYourCompanyData: "Uzupełnij dane swojej firmy",
    filter: "Filtruj",
    filters: "Filtry",
    find: "Wyszukaj",
    findCity: "Wyszukaj miasto",
    findPhrase: "Wyszukaj frazę",
    findFacility: "Wyszukaj wizytówkę",
    followers: "Liczba obserwujących",
    following: "Liczba obserwowanych",
    forgotPassword: "Zapomniałem hasła",
    from: "Od",
    further: "Dalej",
    importedBusinessAddresses: "Zaimportowane wizytówki",
    importFacilities: "Importuj wizytówki",
    facilitiesCountIsOwnerTooltip:
      "Wizytówki zaimportowane z Menedżera Profilu Firmy Google. Te wizytówki możesz edytować.",
    facilitiesCountIsNotOwnerTooltip:
      "Wizytówki dodane spoza Menedżera Profilu Firmy Google. Tych wizytówek nie możesz edytować.",
    facilityOpenStatus: "Status otwarcia",
    importStatus: "Status importu",
    openStatusLabel: {
      all: "Wszystkie",
      open: "Otwarte",
      closedPermanently: "Zamknięte na stałe",
      closedTemporarily: "Tymczasowo zamknięte"
    },
    importStatusLabel: {
      any: "Dowolny",
      imported: "Zaimportowane",
      notImported: "Niezaimportowane"
    },
    facilitiesStatus: "Status wizytówek",
    facilitiesStatusInGoogleMaps: "Status wizytówek w Mapach Google",
    facilitiesStatusInBingMaps: "Status wizytówek w Mapach Bing",
    facilityIsOwnerTooltip:
      "Wizytówka zaimportowana z Menedżera Profilu Firmy Google. Możesz ją edytować.",
    facilityIsNotOwnerTooltip:
      "Wizytówka dodana spoza Menedżera Profilu Firmy Google. Nie możesz jej edytować.",
    freeTrialInfo:
      "Korzystasz z darmowego {0}-dniowego okresu próbnego bez podawania karty płatniczej. Nie zostaniesz obciążony żadnymi opłatami, dopóki samodzielnie nie wybierzesz i nie wykupisz odpowiedniego pakietu w aplikacji.",
    freeTrialTitle: "Korzystaj z Center AI za darmo przez {0} dni",
    general: "Główne",
    generalData: "Dane ogólne",
    gmb_analytics: "Analityka",
    googleMaps: "Mapy Google",
    googleMyBusiness: "Menedżer Profilu Firmy Google",
    facebook: "Facebook",
    govTaxNumber: "NIP",
    history: "Historia",
    importPicked: "Importuj wybrane",
    institution: "Wizytówka",
    lack: "Brak",
    lastAudit: "Ostatni audyt",
    likes: "Polubienia",
    list: "Lista",
    loadingTime: "Czas ładowania",
    location: "Lokalizacja",
    login: "Zaloguj się",
    logOut: "Wyloguj",
    manage: "Zarządzaj",
    maps: "Mapy",
    marketingConsents: "Zgody marketingowe",
    mobileAdaptation: "Dostosowanie do mobile",
    month: "Miesiąc",
    moreInformations: "Więcej informacji",
    moreThan: "Powyżej",
    newLocality: "Nowa lokalizacja",
    newLocation: "Nowa lokalizacja",
    newPassword: "Nowe hasło",
    newTerm: "Nowe hasło",
    newWebsite: "Nowa strona",
    next: "Następny",
    noData: "Brak danych",
    noDataDescription:
      "Jesteśmy w trakcie zbierania danych. Pojawią się tutaj po około kilku godzinach.",
    noChanges: "Brak zmian",
    none: "Brak",
    noRatings: "Brak ocen",
    number_of_photos: "Liczba zdjęć",
    number_of_posts: "Liczba postów",
    ofPages: "z",
    ok: "OK",
    oldPassword: "Stare hasło",
    open: "Otwarte",
    open_hours: "Godziny otwarcia",
    openCloseFacilities: "Otwieranie i zamykanie wizytówek",
    openCloseFacility: "Otwieranie i zamykanie wizytówki",
    openStreetMap: "Open Street Map",
    optional: "Opcjonalnie",
    or: "Lub",
    overview: "Przegląd",
    other: "Inne",
    password: "Hasło",
    performance: "Wydajność",
    perPage: "Pozycji na stronie",
    phone_number: "Numer telefonu",
    photos: "Zdjęcia",
    pickFacilities: "Wybierz wizytówki",
    pickWebsite: "Wybierz stronę www",
    pointer: "Wskaźnik",
    pointers: "Wskazniki",
    poland: "Polska",
    position: "pozycja",
    positionsCount: "Pozycji: {0}",
    positionAbove: "Powyżej {0} pozycji",
    postalCode: "Kod pocztowy",
    postcode: "Kod pocztowy",
    posts: "Wpisy",
    postsAdd: "Dodaj wpis",
    postsEdit: "Edytuj wpis",
    postsList: "Wysłane wpisy",
    previewPhoto: "Dodawane zdjęcie",
    previous: "Poprzedni",
    primaryCategory: "Podstawowa kategoria działalności",
    profile_photo: "Zdjęcie profilowe",
    profileDeleted: "Profil usunięty",
    provideCode: "Wpisz kod",
    quarter: "Kwartał",
    rate: "Ocena",
    rateCenter: "Ocena Center AI",
    refresh: "Odśwież",
    reject: "Odrzuć",
    rememberMe: "Zapamiętaj mnie",
    removeAccount: "Odłącz konto od Center AI",
    removeFacility: "Odłącz wizytówkę",
    removeFacilities: "Odłącz wizytówki",
    removeFilters: "Wyczyść filtry",
    removeProfile: "Odłącz wizytówki od Center AI",
    repeatNewPassword: "Powtórz nowe hasło",
    report: "Raport",
    reportProblem: "Zgłoś problem",
    resend: "Wyślij ponownie",
    resetPassword: "Zmień hasło",
    reviewers: "Liczba ocen klientów",
    reviews_rating: "Średnia ocena klientów",
    reviews: "Ocena w Mapach Google",
    save: "Zapisz",
    saveData: "Zapisz dane",
    savedDoneChanges: "Zmiany zostaną dokonane w",
    facilities: "wizytówkach",
    search: "Szukaj",
    searchCompany: "Szukaj firmy",
    searchEngines: "Wyszukiwarki",
    searchTerm: "Szukaj hasła",
    searchTerms: "Monitorowane hasła",
    security: "Bezpieczeństwo",
    selectAll: "Zaznacz wszystko",
    selectAllFromPage: "Zaznacz wszystko na stronie",
    selectedCount: "Zaznaczono: {0}",
    sendEmail: "Wyślij e-mail",
    seo: "Seo",
    settings: "Ustawienia",
    showHistory: "Pokaż historię",
    showFacility: "Zobacz szczegóły",
    signUp: "Zarejestruj się",
    signUpTrial: "Wypróbuj za darmo",
    signUpTitle:
      "Dbaj o lokalną widoczność i reputację firmy. Zyskuj lojalnych klientów i rozwijaj biznes.",
    signUpTrialTitle:
      "Zarejestruj się teraz i korzystaj z pakietu Standard przez {0} dni za darmo <b>bez podawania karty płatniczej</b>. Bez zobowiązań – sprawdź, jak Center AI pomoże Ci pozyskać lokalnych klientów.",
    skip: "Pomiń",
    social: "Społeczność",
    socialMedia: "Media społecznościowe",
    sort: "Sortuj",
    sortBy: "Sortuj po",
    speed: "Szybkość",
    status: "Status",

    statusOnGoogleMaps: "Status w Mapach Google",
    statusOnGMB: "Status w Menedżerze Profilu Firmy Google",
    storeCode: "Kod sklepu",
    street: "Ulica",
    subscription: "Subskrypcja",
    suggested: "Sugerowane",
    summary: "Podsumowanie",
    tasksToDo: "Zadania do wykonania",
    termsOfService: "Polityka prywatności",
    trade: "Branża",
    tryAgain: "Spróbuj ponownie",
    to: "do",
    urlAttribute: "Atrybut URL",
    user_activity_score: "Twoja aktywność",
    userAccount: "Konto użytkownika",
    userName: "Nazwa użytkownika",
    userProfile: "Profil użytkownika",
    voivodeship: "Województwo",
    website: "Strona www",
    websites: "Strony www",
    week: "Tydzień",
    www_analytics: "Analiza www",
    year: "Rok",
    yourBusinessAddress: "Twoja wizytówka",
    yourBusinessAddresses: "Twoje wizytówki",
    yourCompany: "Twoja firma",
    yourPosition: "Twoja pozycja",
    yourPositionOnGoogleMaps: "Pozycja w wynikach wyszukiwania w Mapach Google",
    yourSite: "Twoja strona",
    yourVisibility: "Twoja widoczność",
    yourWebsite: "Twoja strona www",
    yourWebsites: "Twoje strony www",
    csv: "CSV",
    xls: "XLS",
    xlsx: "XLSX",
    yes: "Tak",
    no: "Nie",
    see: "Zobacz",
    copiedToClipboard: "Skopiowano do schowka",
    filterByDateOf: "Pokazuj opinie które w wybranym okresie zostały",
    reviewLastEdit: "Edytowane",
    reviewCreation: "Utworzone",
    reviewLastEditOrCreation: "Edytowane lub utworzone",
    validation: {
      urlWithProtocol: "Adres linku musi zaczynać się od http:// lub https://",
      requiredField: "Pole jest wymagane",
      maxLength: "Maksymalna długość to {0} znaków",
      minLength: "Minimalna długość to {0} znaków",
      minWords: "Minimalna liczba słów to {0}"
    }
  },

  pluralForms: {
    facility: ["wizytówka", "wizytówki", "wizytówek"],
    facilityGenitive: ["wizytówki", "wizytówek", "wizytówek"],
    facilityLocative: ["wizytówce", "wizytówkach", "wizytówkach"],
    city: ["miasto", "miasta", "miast"],
    group: ["grupa", "grupy", "grup"],
    groupGenitive: ["grupę", "grupy", "grup"],
    review: ["opinia", "opinie", "opinii"],
    position: ["pozycja", "pozycje", "pozycji"],
    click: ["kliknięcie", "kliknięcia", "kliknięć"],
    view: ["wyświetlenie", "wyświetlenia", "wyświetleń"],
    changeAccusative: ["zmianę", "zmiany", "zmian"]
  },

  serviceUnavailable: {
    title: "Przerwa techniczna",
    description:
      "Przepraszamy, panel Center AI oraz API są aktualnie niedostępne, ponieważ trwają prace serwisowe. Dostępność systemu zostanie wkrótce przywrócona.",
    footer: "Dziękujemy za wyrozumiałość,",
    signature: "Zespół <span style='color: #4a24ac'>Center AI</span>",
    backToMainPage: "Wróć na stronę główną"
  },

  service: {
    accountSuspended:
      "Przykro nam, ale konto w <a href='https://center.ai/' target='_blank'>Center AI</a> zostało tymczasowo zawieszone z powodu nieuregulowania płatności.  Aby przywrócić pełną funkcjonalność konta i móc kontynuować korzystanie z naszego rozwiązania, prosimy o uregulowanie zaległości. W razie pytań lub wątpliwości, skontaktuj się z naszym zespołem obsługi klienta pod adresem <a href='mailto:support@center.ai'>support@center.ai</a>.",
    subscriptionPlanExpired:
      "Twój pakiet stracił ważność. Aby odnowić pakiet przejdź do ustawień.",
    wrongSubscriptionPlan: "Twój pakiet nie pozwala na wykonanie tej operacji.",
    subscriptionLimit:
      "Przekroczono limit liczby wizytówek. Twój pakiet pozwala na dodanie X wizytówek. Aby zwiększyć liczbę wizytówek skontaktuj się z nami."
  },

  dashboard: {
    descriptionFirstPart:
      "Dashboard pokazuje podsumowanie dotyczące widoczności twojej firmy w wyszukiwarce Google i na Mapach. Na ogólną ocenę widoczności wpływa kilka wskaźników takich jak: widoczność stron www w wyszukiwarkach internetowych, widoczność wizytówek w Mapach Google i innych mapach, jakość profili w Mapach Google, jakość profili w mediach społecznościowych i jakość stron www. Ocena Center AI jest w skali 0-100 punktów. Aby dowiedzieć się jak obliczamy ocenę ogólną i poszczególne wskaźniki kliknij ikonę",
    descriptionSecondPart: "przy wskaźnikach.",
    overallRate: "Ocena Center AI - ocena ogólna",
    yourVisibility: "Ocena Center AI - poszczególne wskaźniki",
    history: "Ocena Center AI - historia",
    clientScoreHistory:
      "Historia ocen od klientów dla twoich wizytówek w Mapach Google",
    lastMonth: "od ostatniego miesiąca",
    googleOrganic: "Widoczność w wyszukiwarce Google",
    googleOrganicCompetition: "Widoczność w wyszukiwarce Google - konkurencja",
    googleMaps: "Widoczność w Mapach Google",
    googleMapsCompetition: "Widoczność w Mapach Google - konkurencja",
    googleMyBusiness: "Jakość wizytówek w Mapach Google",
    websites: "Jakość stron www",
    socialMedia: "Jakość profili w social mediach",
    otherMaps: "Widoczność na innych mapach",
    fromLastWeek: "od ostatniego tygodnia",
    fromLastMonth: "od ostatniego miesiąca",
    fromLast30Days: "w ciągu ostatnich 30 dni",
    selectAll: "Zaznacz wszysko",
    noDataFromLastMonth: "Brak danych z ostatniego miesiąca",
    competitionBusiness: "Konkurencja",
    visibility: "Widoczność",
    quality: "Jakość",

    checkbox: {
      overallRate: "Ocena ogólna",
      googleOrganic: "Widoczność w wyszukiwarce Google",
      googleMaps: "Widoczność w Mapach Google",
      googleMyBusiness: "Jakość wizytówek w Mapach Google",
      websites: "Jakość stron www",
      socialMedia: "Jakość profili w social mediach",
      otherMaps: "Widoczność na innych mapach"
    },

    tooltip: {
      goToMyVisibilityWebsites:
        "Przejdź do stron www w sekcji Twoja Widoczność",
      goToMyVisibilityBusinessAddresses:
        "Przejdź do wizytówek w sekcji Twoja Widoczność",
      goToMyVisibilityOtherMaps:
        "Sprawdź widoczność na innych mapach w sekcji Twoja widoczność",
      goToMyVisibilitySocialMedia:
        'Sprawdź sekcję "media społecznościowe" w "Twoja widoczność"',
      goToMyVisibilityGMB:
        "Sprawdź jakość profili w Mapach Google w sekcji Twoja widoczność",
      goToMyVisibilityAnalytics:
        'Sprawdź jakość stron www w sekcji "Analiza www"',
      overallRate:
        "Ocena Center AI (0-100) - Ogólna ocena biorąca pod uwagę wszystkie oceniane obszary.",
      socialMedia:
        "Ocena Center AI (0-100) - Sumaryczna ocena Twoich profili na Facebooku i Instagramie. Ocena bierze pod uwagę kompletność danych w profilach, ocenę klientów, Twoją aktywność (umieszczanie wpisów) oraz aktywność użytkowników (wpisy, polubienia, liczba obserwujących i komentarze).",
      otherMaps:
        "Ocena Center AI (0-100) - Ocena widoczności Twoich wizytówek na mapach innych niż Mapy Google (np. Bing, Automapa, Targeo, Open Street Map, JakDojade, Yanosik). Ocena jest tym wyższa im więcej Twoich wizytówek można znaleźć na mapach.",
      googleOrganic:
        "Ocena Center AI (0-100) - Ocena widoczności Twojej strony internetowej. Ocena jest obliczana na podstawie średniej pozycji w wynikach wyszukiwania w Google Twojej strony internetowej dla wszystkich monitorowanych haseł i lokalizacji.",
      googleMaps:
        "Ocena Center AI (0-100) - Ocena widoczności Twoich wizytówek w Mapach Google. Ocena jest obliczana na podstawie średniej pozycji w wynikach wyszukiwania w Mapach Google wszystkich Twoich wizytówek dla wszystkich monitorowanych haseł. Wyszukiwania odbywają się w okolicy Twoich wizytówek.",
      googleMyBusiness:
        "Ocena Center AI (0-100) - Sumaryczna ocena profili wszystkich Twoich wizytówek w Mapach Google. Ocena bierze pod uwagę kompletność danych w profilach, oceny klientów oraz aktywność Twoich klientów (nowe oceny i komentarze).",
      websites:
        "Ocena Center AI (0-100) - Sumaryczna ocena wszystkich Twoich stron www pod kątem wydajności, dostosowania do SEO, dostosowania do osób z niepełnosprawnościami oraz zastosowania dobrych praktyk programistycznych."
    },
    title: "Witaj ponownie!",
    daysRange: "Ostatnie {0} dni",
    widgetTitle: {
      averageRating: "Średnia ocena",
      ratingCount: "Liczba ocen",
      repliesPercentage: "% odpowiedzi na opinie",
      ratingDistribution: "Rozkład ocen",
      bestGmbAddresses: "Najwyżej oceniane wizytówki",
      worstGmbAddresses: "Najniżej oceniane wizytówki",
      lowestQualityGmbAddresses:
        "Lokale z najniższą jakością wizytówek w Mapach Google",
      postsCount: "Liczba dodanych wpisów",
      viewsCount: "Liczba wyświetleń wizytówek",
      queriesCount: "Liczba wyszukiwań wizytówek",
      queries: "Rodzaje wyszukiwań",
      actionsDrivingDirections: 'Liczba akcji "Prowadź do"',
      actionsWebsite: 'Liczba akcji "przejdź do strony www"',
      actionsPhone: 'Liczba akcji "zadzwoń"'
    },
    widgetTooltip: {
      comparedToLast30Days: "W porównaniu do poprzednich 30 dni",
      averageRating: "Średnia ocena",
      ratingCount: "Liczba ocen",
      repliesPercentage: "% odpowiedzi na opinie",
      ratingDistribution: "Rozkład ocen",
      bestGmbAddresses: "Najwyżej oceniane wizytówki",
      worstGmbAddresses: "Najniżej oceniane wizytówki",
      lowestQualityGmbAddresses:
        "Lokale z najniższą jakością wizytówek w Mapach Google",
      postsCount: "Liczba dodanych wpisów",
      viewsCount: "Liczba wyświetleń wizytówek",
      queriesCount: "Liczba wyszukiwań wizytówek",
      queries: "Rodzaje wyszukiwań",
      actionsDrivingDirections: 'Liczba akcji "Prowadź do"',
      actionsWebsite: 'Liczba akcji "przejdź do strony www"',
      actionsPhone: 'Liczba akcji "zadzwoń"'
    },
    ratingDistributionSerie: 'Ocena "{0}"',
    addressScore: "Jakość {0}/100",
    queriesSerie: {
      direct: "Bezpośrednie",
      indirect: "Odkrywanie",
      chain: "Według marki"
    }
  },

  tooltip: {
    indicator: "Kliknij, aby zobaczyć szczegółowe informacje"
  },

  session: {
    accountTypeSelection: {
      employee: "Pracownik",
      company: "Firma",
      ifHaveAnAccount: "lub jeśli masz już konto",
      signUpAs: "Zarejestruj się jako",
      companyOwnerText: `Jestem administratorem lub właścicielem firmy. Chcę założyć konto dla mojej organizacji.`,
      employeeText: `W firmie używamy już Center AI. Chcę uzyskać dostęp do aplikacji.`
    },
    employeePage: {
      title: "Rejestracja pracownika",
      description1: `Jeśli Twoja firma korzysta już z Center AI powinieneś dostać zaproszenie na Twój adres e-mail.`,
      description2: `Jeśli nie otrzymałeś zaproszenia, poproś swojego administratora o wysłanie zaproszenia.`,
      ifHaveAnAccount: "... a jeśli masz już konto"
    },
    dontHaveAccount: "Nie masz konta?",
    haveAccount: "Posiadasz już konto w Center AI?",
    loginWithFacebook: "Zaloguj się z Facebook",
    loginWithGoogle: "Zaloguj się z Google",
    signUpWithFacebook: "Zarejestruj się z Facebook",
    signUpWithGoogle: "Zarejestruj się z Google",

    login: {
      description: "Podaj e-mail i hasło, aby zalogować się do panelu"
    },

    forgot: {
      description: "Podaj swój e-mail, aby otrzymać link do zmiany hasła"
    },

    reset: {
      description: "Potwierdź swoje hasło do zmiany"
    },

    register: {
      privacyPolicy: "polityką prywatności",
      regulations: "regulaminem",
      bySigningUpYouAgreeTo:
        "Rejestrując konto potwierdzasz, że zapoznałeś się z {privacyPolicy} i {regulations} Center AI oraz akceptujesz warunki regulaminu.",
      consent_1:
        "Wyrażam zgodę na dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
      consent_2:
        "Wyrażam zgodę na consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud.",
      consent_3:
        "Wyrażam zgodę na przesyłanie mi newslettera i wiadomości marketingowych (w każdej chwili możesz zmienić zdanie)."
    },

    agreement: {
      newsletterAndMarketing:
        "Wyrażam zgodę na przesyłanie mi newslettera i komunikację marketingową."
    }
  },

  notification: {
    userLoggedInSuccess: "Użytkownik zalogowany z powodzeniem!",
    activationCodeWasAdded: "Kod aktywacyjny został dodany.",
    changesSaved: "Zmiany zostały zapisane pomyślnie",
    activationCodeWasNotAdded:
      "Nie możesz użyć tego kodu aktywacyjnego. Jest on nieważny lub dotyczy niższego pakietu niż Twój.",
    noCompetitionAdded:
      "Nie dodano bądź nie wybrano żadnej wizytówki konkurencyjnej do porównania"
  },

  visibility: {
    summary: {
      businessAddressesTitle: "Widoczność w Mapach Google",
      websitesTitle: "Widoczność w wyszukiwarce Google",
      noBusinessAddressesInfo:
        "Dodając adres wizytówki masz możliwość podglądu mapy prezentującej na jakiej pozycji w wyszukiwarce Google znajduje się Twoja firma.",
      noKeywordsInfo:
        "Dla każdego dodanego hasła (frazy kluczowej) Center AI będzie monitorować pozycję Twoich wizytówek w wyszukiwarce w Google Maps. Aby dodać hasła należy najpierw dodać wizytówki do Center AI.",
      noWebsiteAddress: "Brak adresu strony www",
      noWebsiteAddressInfo:
        "Dodając adres swojej strony, będziesz mógł zobaczyć swoje miejsce w rankingu.",
      dataCollectionPendingForKeyword:
        "Jesteśmy w trakcie zbierania danych dla tego słowa kluczowego.",
      dataCollectionForKeywordTryAgainLater:
        "Nasze radary zostały aktywowane! Jesteśmy w trakcie zbierania danych.",
      addKeywords: "Dodaj słowa kluczowe.",

      map: {
        info:
          "Na mapie widzisz Twoją pozycję w Mapach Google dla wybranego słowa kluczowego, w zależności od miejsca, w którym znajduje się osoba szukająca (Twój potencjalny klient). Kolory oznaczają pozycję - od zielonego, który oznacza wysoką pozycję (bliską 1), po czerwony, który oznacza pozycję bliską 20 (słabą). Kolor szary oznacza pozycję bardzo słabą, poza pierwszą 20 wyników wyszukiwania.",
        subtitle: "Pozycja Twoich wizytówek w wyszukiwarce Map Google",
        legend: {
          high: "Wysoka",
          medium: "Średnia",
          low: "Niska",
          info:
            "Pozycja Twojej wizytówki w wyszukiwarce Map Google dla danego hasła:",
          nodata: "Brak"
        }
      },

      chart: {
        title: "Średnia pozycja wizytówki w okolicy",
        description:
          "Wykres pokazuje średnią pozycję Twojej wizytówki w jej najbliższej okolicy."
      },

      websites: {
        chart: {
          yAxisLabel: "Pozycja w wynikach wyszukiwania Google"
        },
        subtitle:
          "Pozycja Twojej strony www w wyszukiwarce Google dla danego hasła"
      }
    },

    GMBSummary: {
      history: {
        select: {
          centerRate: "Ocena Center AI",
          googleMapsRate: "Ocena w Mapach Google",
          googleMapsRatingQty: "Liczba ocen w Mapach Google",
          profileCompletness: "Kompletność profilu"
        }
      },
      rate:
        "Ocena Center AI (0-100) - Ogólna ocena profilu Twojej wizytówki w Mapach Google. Ocena bierze pod uwagę kompletność danych w profilu, ocenę klientów oraz aktywność Twoich klientów (nowe oceny i komentarze).",
      avgRateInfo:
        "Najtrafniejsze opinie (komentarze) to zazwyczaj trzy wyróżnione opinie wyświetlane na głównej stronie Twojej wizytówki w Mapach Google. Klienci widzą właśnie te opinie w pierwszej kolejności."
    },

    socialMedia: {
      title: "Jakość profili w mediach społecznościowych",

      facebook: {
        clientsActivityInfo:
          "Ocena aktywności osób odwiedzających Twój profil na Facebooku. Ocena jest w skali 0-100 i bierze pod uwagę między innymi liczbę nowych polubień i nowych komentarzy na Twoim profilu.",
        userActivityInfo:
          "Ocena Twojej aktywności na profilu na Facebooku. Ocena jest w skali 0-100 i bierze pod uwagę między innymi liczbę nowych wpisów (postów) na profilu.",
        rate:
          "Ocena Center AI (0-100) - Ogólna ocena Twojego profilu Facebook. Ocena bierze pod uwagę kompletność danych w profilu, ocenę klientów, Twoją aktywność (umieszczanie wpisów) oraz aktywność użytkowników (polubienia i komentarze)."
      },
      instagram: {
        clientsActivityInfo:
          "Ocena aktywności osób odwiedzających Twój profil na Instagramie. Ocena jest w skali 0-100 i bierze pod uwagę między innymi liczbę nowych osób obserwujących Twój profil, liczbę nowych komentarzy i polubień w Twoich najnowszych zdjęciach.",
        userActivityInfo:
          "Ocena Twojej aktywności na profilu na Instagramie. Ocena jest w skali 0-100 i bierze pod uwagę między innymi liczbę nowych wpisów (postów) na profilu.",
        rate:
          "Ocena Center AI (0-100) - Ogólna ocena Twojego profilu Instagram. Ocena bierze pod uwagę Twoją aktywność (dodawanie zdjęć) oraz aktywność użytkowników (polubienia, komentarze oraz liczba obserwujących)."
      }
    },

    mapsVisibility: {
      title: "Obecność Twoich wizytówek na innych mapach",
      tooltip: {
        bing:
          "Mapy firmy Microsoft. Jedne z najbardziej popularnych map w internecie.",
        openStreetMap:
          "Mapy zarządzane w sposób społecznościowy, są darmowe i każdy może dodawać punkty na mapę. Dzięki temu są one bardzo popularne i wykorzystywane przez wiele firm. W Polsce korzysta z nich np. Yanosik i JakDojadę.",
        targeo:
          "Polskie mapy, jedne z najbardziej dokładnych. Korzysta z nich Automapa - popularny system do nawigacji satelitarnej.",
        yanosik:
          "Społecznościowy system ostrzegania o sytuacjach na drodze tworzony przez kierowców, dla kierowców. Korzysta z niego miesięcznie 1,5 mln kierowców w Polsce.",
        jakDojade:
          "Najbardziej popularny w Polsce system do planowania podróży komunikacją zbiorową używany przez 3,5 mln osób miesięcznie. Działa w ponad 45 miastach w całej Polsce. Bardzo popularny zwłaszcza wśród studentów i młodych osób.",
        automapa:
          "Jeden z najbardziej popularnych systemów nawigacji satelitarnej w Polsce. Używany i chwalony przez wielu kierowców."
      }
    }
  },

  competition: {
    header: "Konkurencyjne strony www",
    businessAddresses: {
      title: "Konkurencyjne wizytówki",
      noSuggested: "Brak sugerowanych wizytówek konkurencji",
      suggestedTooltip:
        "Wizytówki, które pojawiają się w wynikach wyszukiwania dla Twoich haseł",
      label: {
        yourBusinessAddress: "Adres Twojej wizytówki",
        addCompetitionBusinessAddress: "Dodaj wizytówkę konkurencji"
      },
      noData:
        "W celu dodania konkurencji wpisz nazwę konkurencyjnej firmy oraz miasto lub wybierz wizytówki spośród sugerowanych poniżej."
    },
    visibility: {
      businessAddresses: {
        chartTitle: "Średnia pozycja wizytówki i konkurencji w okolicy",
        chartDescription:
          "Wykres pokazuje średnią pozycję Twojej wizytówki i wybranych wizytówek konkurencyjnych w najbliższej okolicy Twojej wizytówki.",
        cardTitle: "Sprawdź kto wygrywa w twojej okolicy",
        cardDescription:
          "Wybierz adres swojej wizytówki, maksymalnie 5 wizytówek konkurencji oraz hasło dla którego chcesz zobaczyć wyniki",
        cardInfo:
          "Kolory na mapie reprezentują wizytówki i pokazują, która wizytówka jest najwyżej w wynikach wyszukiwania w Mapach Google (wśród wybranych wizytówek) dla wybranego hasła w zależności od miejsca, w którym znajduje się osoba szukająca (Twój potencjalny klient). Na przykład kolor pomarańczowy oznacza miejsca, w których osoba szukająca wybranego hasła najwyżej widzi Twoją wizytówkę (wśród wybranych wizytówek).",
        inputLegend: "Twoja wizytówka na mapie",
        listTitle: "Wizytówki konkurencyjne",
        listNoData: "Brak wizytówek konkurencji",
        searchingData:
          "Jesteśmy w trakcie zbierania danych dla tego słowa kluczowego.",
        addNewTerm: "Dodaj słowa kluczowe."
      },
      title: "Widoczność konkurencji w Google i w Mapach Google",
      keywordsTitle: "Monitorowane hasła",
      nodata: {
        title: "Brak adresu strony www",
        content:
          "Dodając adres swojej strony, będziesz mógł zobaczyć wyniki dla konkurencji."
      }
    },
    websites: {
      label: {
        yourWebsiteAddress: "Adres do Twojej strony www",
        localization: "Lokalizacja",
        competitionWebsiteAddress: "Adres strony www konkurencji"
      },

      suggestedTooltip:
        "Strony, które pojawiają się w wynikach wyszukiwania dla Twoich haseł",
      inputPlaceholder: "Wpisz adres strony www",
      chart: {
        yAxisLabel: "Pozycja w wynikach wyszukiwania Google"
      }
    }
  },

  analytics: {
    siteLoadingInfo:
      "Strony, które ładują się szybko są lepiej odbierane przez użytkowników i użytkownicy spędzają na nich więcej czasu. Jako czas ładowania strony pokazujemy czas potrzebny do wyświetlenia na ekranie głównej zawartości strony (pierwszego znaczącego elementu na stronie).",
    generateRaport: "Wygeneruj raport",
    auditMade: "Audyt wykonano",
    wellDone: "Dobrze wykonane",
    needFix: "Do poprawy",
    scale: {
      great: "Świetnie",
      good: "Dobrze",
      medium: "Średnio",
      weak: "Słabo"
    },
    tooltip: {
      seo:
        "SEO to skrót od angielskiej nazwy Search Engine Optimiazation. Są to różnego rodzaju akcje, które sprawiają, że Twoja strona www jest dobrze rozpoznawana przez wyszukiwarki internetowe. To z kolei może przełożyć się na wyższe pozycje w wynikach wyszukiwarek internetowych dla haseł, na których Tobie zależy.",
      performance:
        "Wydajność to szybkość działania i responsywność Twojej strony www. Strony, które ładują się szybko są lepiej odbierane przez użytkowników i użytkownicy spędzają na nich więcej czasu.",
      accessibility:
        "Ułatwienia dostępu pokazują jak bardzo Twoja strona jest łatwa w uzytkowaniu dla osób z niepełnosprawnościami np. dla osób niedowidzących. Jest to ważne ponieważ coraz więcej osób z niepełnosprawnościami korzysta z internetu.",
      best_practices:
        "Dobre praktyki oznaczają dobre praktyki wykorzystywane przez programistów, administratorów i edytorów podczas tworzenia stron www i ich treści. Są to rozwiązania, które warto znać i stosować, ponieważ często pozwalają uniknąć wielu problemów w działaniu strony www."
    },

    businessAddresses: {
      dataCollectInfoText:
        "Od stycznia 2024 roku liczba zapytań o trasę dojazdu może być mniejsza niż wcześniej. Wynika to z tego, że Google zmieniło sposób liczenia tych danych.",
      here: "tutaj",
      archiveAlert1: "Aby zobaczyć poprzednią wersję strony kliknij",
      archiveAlert2:
        'Poprzednia wersja zawiera informacje o liczbie wyszukiwań wizytówek, ale ze względu na zmiany Google wszystkie dane w poprzedniej wersji będą aktualizowane tylko do <span class="text-primary">28 lutego 2023</span>',
      postStatAlert2:
        'Statystyki wpisów będą dostępne tylko do <span class="text-primary">28 lutego 2023</span> (ze względu na zmiany wprowadzone przez Google).',
      noData:
        "Tutaj prezentujemy najważniejsze informacje dotyczące tego jak często użytkownicy wyswietlają Twoje wizytówki w Mapach Google i w wyszukiwarce Google oraz jakie następnie podejmują działania. Te informacje pozwolą Ci lepiej zrozumieć zachowania użytkowników. Dane są udostępnione przez Google i dotyczą tylko wizytówek, ktore zostały zaimportowane do Center AI z Menedżera Profilu Firmy Google",
      title: "Wizytówki w Mapach Google",
      titleTooltip:
        "Tutaj prezentujemy najważniejsze informacje dotyczące tego jak często użytkownicy wyswietlają Twoje wizytówki w Mapach Google i w wyszukiwarce Google oraz jakie następnie podejmują działania. Te informacje pozwolą Ci lepiej zrozumieć zachowania użytkowników. Dane są udostępnione przez Google i dotyczą tylko wizytówek, ktore zostały zaimportowane do Center AI z Menedżera Profilu Firmy Google",
      subtitle: {
        search: "Wyszukiwania wizytówek",
        actions: "Działania klientów na wizytówkach",
        displays: "Wyświetlenia wizytówek"
      },
      noCompare: "Nie porównuj",
      compareWithPreviousPeriod: "Poprzedni okres",
      compareWithPreviousYear: "Poprzedni rok",
      showConversionRate: "Pokaż współczynnik konwersji",
      chart: {
        directDiscoveryBranded: {
          title: {
            text: "Rodzaj wyszukiwania",
            tooltip:
              "Klienci szukają Twoich wizytówek w różny sposób. Czasami wpisują w wyszukiwarce nazwę firmy, czasami adres a czasami nazwę Twojej marki. Tutaj widzisz rozkład liczby wyszukiwań w zależności od typu wyszukiwania."
          },
          label: {
            text: {
              direct: "Wyszukiwania bezpośrednie",
              indirect: "Odkrywanie",
              branded: "Według marki"
            },
            tooltip: {
              direct:
                "Klienci, którzy znaleźli wybrane wizytówki, szukając nazwy firmy lub jej adresu.",
              indirect:
                "Klienci, którzy znaleźli wybrane wizytówki, szukając kategorii, produktu lub usługi.",
              branded:
                "Klienci, którzy znaleźli wybrane wizytówki, szukając marki związanej z Twoją firmą."
            }
          }
        },
        searches: {
          title: {
            text: "Liczba wyszukiwań",
            tooltip:
              "Łączna liczba wyszukiwań wszystkich rodzajów w danym okresie."
          }
        },
        searchMaps: {
          title: {
            text: "Wyszukiwarka Google vs Mapy Google",
            tooltip:
              "Klienci mogą zobaczyć Twoje wizytówki zarówno w wyszukiwarce Google jak i w Mapach Google. Tutaj widzisz rozkład liczby wyświetleń wizytówek wybranych wizytówek w zależności od miejsca wyświetlenia."
          },
          label: {
            search: "Wyświetlenia w wyszukiwarce Google",
            maps: "Wyświetlenia w Mapach Google"
          }
        },
        maps: {
          title: {
            text: "Liczba wyświetleń",
            tooltip:
              "Łączna liczba wyświetleń wizytówek wybranych wizytówek zarówno w wyszukiwarce Google jak i w Mapach Google."
          }
        },
        clicks: {
          title: {
            text: "Przejścia do Twojej strony www",
            tooltip:
              "Łączna liczba przejść do Twojej strony www z wizytówek w Mapach Google."
          }
        },
        directions: {
          title: {
            text: "Zapytania o trasę dojazdu",
            tooltip:
              "Łączna liczba zapytań o trasę („Prowadź do”) na wizytówkach w Mapach Google."
          }
        },
        calls: {
          title: {
            text: "Połączenia telefoniczne z Twoją firmą",
            tooltip:
              "Łączna liczba połączeń telefonicznych zainicjowanych na wizytówkach w Mapach Google."
          }
        },
        clicksConversion: {
          title: {
            text: "Przejścia do Twojej strony www",
            tooltip:
              "Łączna liczba przejść do Twojej strony www z wizytówek w Mapach Google."
          }
        },
        directionsConversion: {
          title: {
            text: "Zapytania o trasę dojazdu",
            tooltip:
              "Łączna liczba zapytań o trasę („Prowadź do”) na wizytówkach w Mapach Google."
          }
        },
        callsConversion: {
          title: {
            text: "Połączenia telefoniczne z Twoją firmą",
            tooltip:
              "Łączna liczba połączeń telefonicznych zainicjowanych na wizytówkach w Mapach Google."
          }
        },
        common: {
          totalViews: "Liczba wyświetleń",
          conversion: "Współczynnik konwersji"
        }
      }
    },
    websites: {
      noWebsitesAdded: "Nie dodałeś żadnej strony www.",
      addWebsite: "Dodaj stronę www",
      noAuditYetTryAgainLater:
        "Jeszcze nie wykonaliśmy audytu dla tej strony www. Spróbuj później."
    },
    periodic: {
      title: "Pozycja w wynikach wyszukiwania w Mapach Google",
      allSelected: "(wszystkie)",
      keywords: {
        label: "Hasła",
        noKeywords: "Nie masz jeszcze wybranych haseł",
        dialog: {
          [PERIODIC_REPORT_TYPE.TOP]: {
            title: "Wybierz hasła"
          },
          [PERIODIC_REPORT_TYPE.AVERAGE]: {
            title: "Wybierz hasło",
            infoBox:
              "Możesz wybrać tylko jedno hasło do wykresu <b>Średnia pozycja</b>"
          },
          filterInputPlaceholder: "Którego hasła szukasz?"
        }
      },
      types: {
        [PERIODIC_REPORT_TYPE.TOP]: "Pozycje TOP",
        [PERIODIC_REPORT_TYPE.AVERAGE]: "Średnia pozycja"
      },
      tooltip: {
        [PERIODIC_REPORT_TYPE.TOP]:
          "Tutaj możesz zobaczyć jak często wizytówki są widoczne na pozycjach 1-3, 4-10 i 11-20 w wynikach wyszukiwania dla wybranych słów kluczowych",
        [PERIODIC_REPORT_TYPE.AVERAGE]:
          "Tutaj możesz zobaczyć średnią pozycję dla twojej wizytówki w wyniakch wyszukwiania dla wybranych słów kluczowych, w wybranym przedziale czasowym."
      },
      chart: {
        tabTitle: "Wykres",
        yAxisLabel: {
          [PERIODIC_REPORT_TYPE.TOP]: "Liczba wizytówek",
          [PERIODIC_REPORT_TYPE.AVERAGE]:
            "Średnia pozycja w wynikach wyszukiwania w Mapach Google"
        },
        noKeywordsDescription:
          "Wybierz hasła, a my wyświetlimy dla Ciebie\nodpowiednie wykresy"
      },
      table: {
        tabTitle: "Tabela",
        noKeywordsDescription: "Wybierz hasła, aby przeglądać dane w tabeli",
        groupFacilities: "Zgrupuj wizytówki",
        gmbAddress: "Wizytówka",
        group: "Grupa",
        summary: "Podsumowanie",
        summarySecondaryText: "wszystkich wybranych wizytówek"
      }
    },
    comparator: {
      title: "Porównywanie wizytówek",
      showDifference: "Pokaż różnice",
      addDescription:
        "Na tym ekranie porównasz ze sobą dwa zbiory wizytówek. Aby zobaczyć porównanie wybierz wizytówki w obu zbiorach (A i B).",
      groupA: "Zbiór wizytówek A",
      groupB: "Zbiór wizytówek B",
      addFacilities: "Wybierz wizytówki",
      reviewsOverall: "Opinie - wszystkie",
      reviewsLastMonth: "Opinie - ostatnie 30 dni",
      averageRating: "Średnia ocena",
      mostAccurateAverageRating: "Średnia z najtrafniejszych ocen",
      reviewsCount: "Liczba opinii",
      reviewsRatings: "Rozkład opinii",
      reviewsAswersPercentage: "% odpowiedzi na opinie",
      postsOverall: "Wpisy - wszystkie",
      postsLastMonth: "Wpisy - ostatnie 30 dni",
      posts: "Liczba wpisów",
      postsDistribution: "Rozkład typów wpisów",
      postType: {
        [POST_TYPE.STANDARD]: "Standard",
        [POST_TYPE.EVENT]: "Wydarzenie",
        [POST_TYPE.OFFER]: "Oferta",
        [POST_TYPE.ALERT]: "Alert"
      }
    }
  },

  companyProfile: {
    tab: {
      termsInBrowsers: "Monitorowane hasła"
    },
    settings: {
      subscriptionInfo: "Aby zmienić rodzaj konta wpisz kod aktywacyjny",
      subscriptionType:
        'Korzystasz z pakietu "{variable}", który jest ważny do końca {variable2}',
      subscriptionName: "Plan: {name}",
      subscriptionExpiration: "Data kolejnego odnowienia: {date}",
      subscriptionExpired: "Twój plan abonamentowy wygasł",
      manageSubscription: "Zarządzaj planem",
      pay: "Opłać faktury",
      expired:
        "Twój pakiet wygasł. Aby go przedłużyć skontaktuj się z nami na chacie lub mailowo (support@center.ai)."
    },
    noData: {
      title:
        "Brak podpiętego konta Profil Firmy (Menedżer Profilu Firmy Google).",
      description:
        "Dodaj konto Profilu Firmy, aby w pełni korzystać z możliwości jakie daje Center AI. Dzięki integracji będziesz mógł m.in. zbiorczo edytować wizytówki, zbiorczo publikować wpisy oraz monitorować pozycje swoich wizytówek na słowa kluczowe w wynikach wyszukiwania w Mapach Google."
    },
    listings: {
      title: "Konta Google",
      subtitle: {
        mainSection: "Podpięte konta"
      },
      description: {
        mainSection:
          "Aby korzystać z Center AI konieczne jest podpięcie konta Profilu Firmy (Menedżer Profilu Firmy Google) i zaimportowanie wizytówek. Tutaj znajduje się lista kont, które zintegrowałeś z Center AI."
      },
      refreshInfo:
        "Nie widzisz wizytówki na liście? Dane są pobierane co 10 minut. Spróbuj ponownie za chwilę.",
      importSummary: {
        locationsImport: "Import wizytówek",
        lastImport: "Ostatni import:",
        importedLocations: "Zaimportowane wizytówki:",
        importedStatistics: "Zaimportowano {current_count} z {total_count}",
        importInProgress: "Trwa import danych",
        lastCheckedAt: "Ostatnie sprawdzenie {time}",
        dialogMessages: {
          importing: "Wizytówki wybrane do importu: {importing_count}",
          successfullyImported: "Zaimportowane wizytówki:  {success_count}",
          error:
            "Niektóre wizytówki ({error_count}) nie zostały zaimportowane, ponieważ nie udało się pobrać dla nich wszystkich wymaganych informacji.",
          alreadyImported:
            "Część wizytówek ({already_imported_count}) była już wcześniej zaimportowana w ramach innego konta Google i nie było potrzeby importowania ich ponownie.",
          unverified: "Zignorowane niezweryfikowane wizytówki:"
        }
      },
      actionsDisabledDuringImport:
        "W trakcie importu ten ekran jest nieaktywny, ale możesz korzystać z innych funkcji.",
      deleteBusinessAddressesListDialog: {
        title: "Wybierz wizytówki, które chcesz odłączyć od Center AI"
      },
      businessAddressesListDialog: {
        noData: "Brak wizytówek dla tego konta",
        title: "Wybierz wizytówki, które chcesz zaimportować",
        statuses: {
          is_disabled: "Wyłączona",
          is_disconnected: "Odłączona",
          is_duplicate: "Duplikat",
          is_pending_review: "W trakcie sprawdzania",
          is_permanently_closed: "Zamknięta",
          is_published: "Opublikowana",
          is_suspended: "Zawieszona",
          is_verified: "Zweryfikowana",
          needs_reverification: "Wymaga ponownej weryfikacji"
        }
      },
      confirmationDialog: {
        textImport:
          "Wizytówki zostały zaimportowane i są dostępne na liście Twoich wizytówek.",
        textImportPending: "Trwa import wizytówek.",
        textImportPendingDescription:
          "W między czasie, zachęcamy do sprawdzenia <a href='https://center.ai/blog/' target='_blank'>naszego bloga</a>. Artykuły pomogą Ci  lepiej zrozumieć wartość biznesową Center AI oraz dobre praktyki, które warto stosować.",
        importedStatistics: "Zaimportowano {current_count} z {total_count}",
        textDelete: "Zaznaczone wizytówki zostały usunięte.",
        textProfileDelete:
          "Zaznaczony profil i wszystkie powiązane z nim wizytówki zostały usunięte.",
        textAccountDelete:
          "Konto i wszystkie powiązane profile zostały usunięte.",
        importErrorTitle: "Błąd podczas dodawania konta",
        deleteErrorTitle: "Błąd podczas usuwania konta",
        deleteProfileErrorTitle: "Błąd podczas usuwania profilu",
        deleteAccountErrorTitle: "Błąd podczas usuwania konta Google",
        deleteAccountConfirm: "Czy na pewno chcesz usunąć konto Google?",
        deleteProfileConfirm: "Czy na pewno chcesz usunąć profil?",
        deleteFacilityConfirm:
          "Czy na pewno chcesz odłączyć wizytówkę od Center AI?",
        importErrorText:
          "Coś poszło nie tak... wizytówki nie zostały zaimportowane. Spróbuj ponownie.",
        deleteErrorText:
          "Coś poszło nie tak... Zaznaczone wizytówki nie zostały usunięte. Spróbuj ponownie.",
        deleteProfileErrorText:
          "Coś poszło nie tak... Profil nie został usunięty. Spróbuj ponownie.",
        deleteAccountErrorText:
          "Coś poszło nie tak... konto Google nie zostało usunięte. Spróbuj ponownie.",
        tooManyRequestsErrorText:
          "Twój pakiet nie pozwala na dodanie takiej liczby placówek. Aby zwiększyć liczbę placówek, które możesz dodać skontaktuj się z nami mailowo (support@center.ai) lub korzystając z komunikatora w prawym dolnym rogu ekranu.",
        preAddAccount: {
          title: "Uprawnienia dla Center AI",
          description:
            "Center AI potrzebuje uprawnień dostępu do wizytówek Twojej firmy w Mapach Google. Tylko w ten sposób możemy pomóc w zarządzaniu wizytówkami.",
          descriptionSecondary:
            "Aby dać uprawnienia zaznacz odpowiednie pole wyboru jak pokazano poniżej:",
          imgAlt: "Jak zaznaczyć prawidłowe pole."
        },
        postAddAccount: {
          error: {
            title: "Uprawnienia dla Center AI",
            description:
              "Podczas dodawania konta Google wystąpił błąd, ponieważ wymagane uprawnienia nie zostały nadane.",
            descriptionSecondary:
              "Center AI potrzebuje uprawnień dostępu do wizytówek Twojej firmy w Mapach Google. Tylko w ten sposób możemy pomóc w zarządzaniu wizytówkami."
          }
        }
      },
      noProfilesAdded: "Brak dodanych profili."
    },
    monitoredKeywords: {
      title: "Monitorowane hasła",
      subtitle: "Czego szukają Twoi klienci?",
      subtitleTooltip:
        "Podaj hasła, dla których chcesz monitorować pozycję Twoich wizytówek w wynikach wyszukiwania w Mapach Google.",
      keywordsScope: "Lokalizacja haseł",
      scope: {
        [KEYWORDS_SCOPE.COMPANY]: "Wszystkie wizytówki",
        [KEYWORDS_SCOPE.GROUP]: "Grupa",
        [KEYWORDS_SCOPE.FACILITY]: "Wybrana wizytówka"
      },
      keywordsSection: {
        title: "Monitorowane hasła",
        keywordInputPlaceholder: "Podaj hasło",
        infoBoxContent:
          "Jeśli chcesz dodać hasło do listy, wpisz frazę w polu powyżej, a następnie wciśnij klawisz “Enter” na klawiaturze lub przycisk “Dodaj”.",
        noKeywords: "Nie masz jeszcze dodanych żadnych haseł",
        noKeywordsAlt: "Brak haseł"
      },
      deleteDialogLabel: "Czy na pewno chcesz usunąć wybrane hasło?",
      chosenKeywordDeleted: "Wybrane hasło zostało usunięte"
    }
  },

  facilityDetails: {
    title: "Szczegóły wizytówki",
    backToFacilitiesList: "Wróć do listy wizytówek",
    showIn: "Pokaż w",
    mapButton: "Mapach Google",
    bingMapButton: "Mapach Bing",
    startDate: "Data otwarcia",
    openingHours: "Godziny otwarcia",
    openingHoursInfoText:
      "Powyższe godziny otwarcia zostaną ustawione dla całego tygodnia. Na przykład: jeżeli ustawisz godziny otwarcia tylko dla poniedziałku na 9:00 - 17:00 a pozostałe dni będą ustawione jako zamknięte to zmodyfikowane zostaną godziny otwarcia zarówno dla poniedziałku jak i wszystkich pozostałych dni tygodnia (zgodnie z informacjami w formularzu powyżej).",
    customOpeningHours: "Niestandardowe godziny otwarcia",
    customOpeningHoursInfoText:
      "Godziny otwarcia zostaną ustawione tylko dla dni wybranych powyżej. Żaden inny dzień nie zostanie zmodyfikowany.",
    allDayOpeningHours: "Czynne całą dobę",
    statusOnMaps: "Status na Mapach",
    typeOfMap: "Mapa",
    status: "Status",
    details: "Szczegóły",
    lastUpdateDate: "Data ostatniej aktualizacji",
    reviewFormLink: "Link do formularza dodawania opinii w Mapach Google",
    technicalDetailsDialog: {
      title: "Szczegóły techniczne wizytówki",
      locationName: "gmb_location_name"
    },
    statuses: {
      pending: "Oczekuje na aktualizację",
      inProgress: "W trakcie aktualizacji",
      ok: "Aktualne",
      failed: "Niepowodzenie aktualizacji",
      externalChange: "Nowe zmiany zewnętrzne",
      noData: "Brak danych statusu",
      lastUpdateNoData: "Brak daty ostatniej aktualizacji"
    },
    statusDescription:
      "Center AI automatycznie wysyła informacje o Twoich wizytówkach do Map Google. Tabela poniżej pokazuje kiedy dane o wizytówce zostały wysłane do Map Google. Aktualizacje zazwyczaj są widoczne  w Mapach Google w ciągu kilku minut od wysłania, natomiast czasami pojawiają się po nieco dłuższym czasie (Google czasami przeprowadza weryfikację danych przed opublikowaniem).",
    forms: {
      streetAndHomeNumber: "Numer domu/mieszkania",
      websiteAddress: "Adres strony www",
      phoneOne: "Numer telefonu 1",
      phoneTwo: "Numer telefonu 2"
    },
    addWorkingHours: "Dodaj godziny pracy",
    addAnotherDay: "Dodaj kolejny dzień",
    validation: {
      date: "Rok i miesiąc są wymagane"
    },
    footer: {
      openingHours:
        "Po zapisaniu, zmiany podlegają weryfikacji ze strony Google, przez co ich publikacja może potrwać do 3 dni. W praktyce zazwyczaj następuje to w czasie do kilku minut."
    },
    noChangesInForm:
      "Brak zmian w formularzu. Zaznacz pola, które chcesz zaktualizować",
    facilityDescription: "Opis wizytówki",
    urlAttributes: {
      title: "Atrybuty URL",
      facilityAttributes: "Atrybuty URL wizytówki",
      facilitiesAttributes: "Atrybuty URL wizytówek",
      noAttributesSelected: "Nie masz wybranych żadnych atrybutów URL",
      editMessage:
        "Dodaj lub usuń atrybuty URL (linki), np. link do menu Twojej restauracji, aby przekazać swoim klientom więcej informacji.",
      addAttributes: "Dodaj atrybuty URL",
      addAttributesInfo:
        "Dodaj atrybuty URL, aby przekazać swoim klientom więcej informacji o Twoich wizytówkach oraz umożliwić im łatwiejsze dotarcie do ważnych źródeł zewnętrznych.",
      addingAttributes: "Dodajesz atrybuty URL",
      addAttributesQuestion: "Chcesz dodać dodatkowe atrybuty URL?",
      addAttributesDescription:
        "Podaj nowe atrybuty URL, które chcesz dodać do wybranych wizytówek. Atrybuty URL zostaną dodane do już istniejących atrybutów URL zachowując stan innych atrybutów URL.",
      deleteAttributes: "Usuń atrybuty URL",
      deletingAttributes: "Usuwasz atrybuty URL",
      deleteAttributesQuestion: "Chcesz usunąć wybrane atrybuty URL?",
      deleteAttributesDescription:
        "Wybierz atrybuty URL, które chcesz usunąć z wybranych wizytówek. Tylko wybrane atrybuty URL zostaną usunięte. Inne atrybuty URL pozostaną nienaruszone.",
      changeType: "Chcesz jednak zrobić coś innego? Wybierz:",
      changeTypeConfirm:
        "Zmiana sposobu edycji atrybutów spowoduje, że wyczyścimy w formularzu do masowej edycji dane, które wprowadziłeś w polu “Atrybuty URL wizytówek”. Wyczyścimy dane tylko w tym formularzu, natomiast w twoich wizytówkach atrybuty URL się nie zmieniają. Czy chcesz kontynuować?",
      dialog: {
        title: "Atrybuty URL",
        description: "Poniżej możesz dodawać, usuwać i edytować atrybuty URL.",
        noAttributes: "Brak atrybutów URL",
        noAttributesAvailable:
          "Do tej wizytówki nie można dodać dodatkowych atrybutów URL. Dodatkowe atrybuty URL są dostępne tylko dla niektórych kategorii wizytówek (np. restauracje).",
        noAttributesToDeleteMassEdit:
          "Nie ma żadnych atrybutów URL do usunięcia.",
        noAttributesAvailableMassEdit:
          "Do tych wizytówek nie można dodać atrybutów URL, ponieważ nie mają wspólnych atrybutów URL",
        notEditable:
          "Adresów URL w tej sekcji nie można edytować (nie pozwala na to Google).",
        validationError:
          "Niektóre pola formularza zawierają nieprawidłowe adresy URL. Popraw je, a następnie zapisz ponownie.",
        addAttributeBtn: "Dodaj atrybut URL",
        applyBtn: "Zapisz"
      }
    },
    services: {
      validation: {
        descriptionLength: "Opis usługi nie może przekraczać {0} znaków",
        serviceExists: "Usługa już istnieje",
        required: "Pole wymagane"
      },
      addServiceInfo:
        "Usługi niestandardowe zostaną dodane do głównej kategorii biznesowej w wybranych wizytówkach.",
      addDescription: "Dodaj opis",
      title: "Usługi",
      selectServiceCategory: "Wybierz kategorię usług",
      noServicesSelected: "Nie masz wybranych żadnych usług",
      addServicesInfo: "Dodaj usługi, które oferujesz w swojej firmie.",
      addAnotherCustomService: "Dodaj kolejną niestandardową usługę",
      addCustomService: "Dodaj niestandardową usługę",
      addNext: "Dodaj kolejną usługę",
      customService: "Niestandardowa usługa",
      customServices: "Niestandardowe usługi",
      standard: "Standardowe",
      custom: "Niestandardowe",
      missingServiceQuestion: "Nie widzisz usługi którą oferujesz?",
      serviceDescription: "Opis usługi",
      servicePrice: "Cena usługi ({0})",
      price: "Cena",
      noPrice: "Brak ceny",
      priceFrom: "Cena od",
      priceTo: "Cena do",
      fixedPrice: "Cena stała",
      deleteService: "Usuń usługę",
      deleteServiceDialogText: "Czy na pewno chcesz usunąć tę usługę?",
      closeServiceDialogText:
        "Czy na pewno chcesz zamknąć okno? Niezapisane zmiany zostaną utracone.",
      addServices: "Dodaj usługi",
      editServices: "Edycja usługi",
      deleteServices: "Usuń usługi",
      findService: "Wyszukaj usługi",
      addingServices: "Dodajesz usługi",
      addServicesQuestion: "Chcesz dodać dodatkowe usługi?",
      addServicesDescription:
        "Wybierz nowe usługi, które chcesz dodać do wybranych wizytówek. Usługi zostaną dodane do już istniejących usług zachowując stan innych usług.",
      deletingServices: "Usuwasz usługi",
      deleteServicesQuestion: "Chcesz usunąć wybrane usługi?",
      deleteServicesDescription:
        "Wybierz usługi, które chcesz usunąć z wybranych wizytówek. Tylko wybrane usługi zostaną usunięte. Inne usługi pozostaną nienaruszone.",
      overwriteServices: "Ustaw usługi",
      overwritingServices: "Ustawiasz usługi",
      overwriteServicesQuestion: "Chcesz ustawić (nadpisać) usługi?",
      overwriteServicesDescription:
        "Wybierz usługi, które chcesz ustawić w wybranych wizytówkach. Ta operacja spowoduje, że wszystkie obecne usługi zostaną usunięte i zastąpione tymi wybranymi przez Ciebie.",
      clickToRestore: "Kliknij, aby przywrócić",
      duplicateError: "Usługa {0} już istnieje",
      changeType: "Chcesz jednak zrobić coś innego? Wybierz:",
      changeTypeConfirm:
        "Zmiana sposobu edycji usług spowoduje, że wyczyścimy w formularzu do masowej edycji dane, które wprowadziłeś w polu “Usługi”. Wyczyścimy dane tylko w tym formularzu, natomiast w twoich wizytówkach usługi się nie zmieniają. Czy chcesz kontynuować?"
    },
    attributes: {
      title: "Atrybuty",
      facilityAttributes: "Atrybuty wizytówki",
      facilitiesAttributes: "Atrybuty wizytówek",
      findAttributes: "Wyszukaj atrybuty",
      facilityDescription: "Opis wizytówki",
      noAttributesSelected: "Nie masz wybranych żadnych atrybutów",
      editMessage:
        "Dodaj, usuń lub ustaw atrybuty, aby przekazać swoim klientom więcej informacji o Twoich wizytówkach oraz wskazać im najważniejsze atuty. Atrybuty to na przykład informacje o płatności kartą, wejściu dla niepełnosprawnych czy darmowym Wifi.",
      addAttributes: "Dodaj atrybuty",
      addAttributesInfo:
        "Dodaj atrybuty, aby przekazać swoim klientom więcej informacji o Twoich wizytówkach oraz wskazać im najważniejsze atuty. Atrybuty to na przykład informacje o płatności kartą, wejściu dla niepełnosprawnych czy darmowym Wifi.",
      addingAttributes: "Dodajesz atrybuty",
      addAttributesQuestion: "Chcesz dodać dodatkowe atrybuty?",
      addAttributesDescription:
        "Wybierz nowe atrybuty, które chcesz dodać do wybranych wizytówek. Atrybuty zostaną dodane do już istniejących atrybutów zachowując stan innych atrybutów.",
      deleteAttributes: "Usuń atrybuty",
      deletingAttributes: "Usuwasz atrybuty",
      deleteAttributesQuestion: "Chcesz usunąć wybrane atrybuty?",
      deleteAttributesDescription:
        "Wybierz atrybuty, które chcesz usunąć z wybranych wizytówek. Tylko wybrane atrybuty zostaną usunięte. Inne atrybuty pozostaną nienaruszone.",
      overwriteAttributes: "Ustaw atrybuty",
      overwritingAttributes: "Ustawiasz atrybuty",
      overwriteAttributesQuestion: "Chcesz ustawić (nadpisać) atrybuty?",
      overwriteAttributesDescription:
        "Wybierz atrybuty, które chcesz ustawić w wybranych wizytówkach. Ta operacja spowoduje, że wszystkie obecne atrybuty zostaną usunięte i zastąpione tymi wybranymi przez Ciebie.",
      changeType: "Chcesz jednak zrobić coś innego? Wybierz:",
      changeTypeConfirm:
        "Zmiana sposobu edycji atrybutów spowoduje, że wyczyścimy w formularzu do masowej edycji dane, które wprowadziłeś w polu “Atrybuty wizytówek”. Wyczyścimy dane tylko w tym formularzu, natomiast w twoich wizytówkach atrybuty się nie zmieniają. Czy chcesz kontynuować?"
    },
    categories: {
      primary: {
        title: "Wybierz podstawową kategorię działalności",
        queryPlaceholder: "Szukaj kategorii",
        applyBtnText: "Ustaw"
      },
      additional: {
        title: "Wybierz dodatkową kategorię działalności",
        queryPlaceholder: "Szukaj kategorii",
        applyBtnText: "Dodaj",
        bulkEditApplyBtnText: "Wybierz",
        bulkEditTooltip:
          "Wybrane kategorie dodatkowe nadpiszą (usuną) kategorie dodatkowe, które są obecnie ustawione w wybranych wizytówkach."
      },
      deleteCategoryDialogTitle: "Czy na pewno chcesz usunąć kategorię?",
      mayNeedVerification:
        "Po dodaniu lub edycji kategorii Google może poprosić o ponowne zweryfikowanie wizytówki"
    },
    labels: {
      title: "Etykiety",
      deleteLabelDialogTitle: "Czy na pewno chcesz usunąć etykietę?",
      facilityLabels: "Etykiety wizytówki",
      facilitiesLabels: "Etykiety wizytówek",
      findLabels: "Wyszukaj etykiety",
      noLabels: "Brak etykiet",
      noLabelsSelected: "Nie masz wybranych żadnych etykiet",
      editMessage:
        "Dodaj, usuń lub ustaw etykiety. Etykiety nie są widoczne publicznie w Mapach Google.",
      addLabels: "Dodaj etykiety",
      addLabelsInfo:
        "Dodaj etykiety, aby przekazać swoim klientom więcej informacji o Twoich wizytówkach oraz wskazać im najważniejsze atuty.",
      addingLabels: "Dodajesz etykiety",
      addLabelsQuestion: "Chcesz dodać dodatkowe etykiety?",
      addLabelsDescription:
        "Wybierz nowe etykiety, które chcesz dodać do wybranych wizytówek. Etykiety zostaną dodane do już istniejących etykiet zachowując stan innych etykiet.",
      deleteLabels: "Usuń etykiety",
      deletingLabels: "Usuwasz etykiety",
      deleteLabelsQuestion: "Chcesz usunąć wybrane etykiety?",
      deleteLabelsDescription:
        "Wybierz etykiety, które chcesz usunąć z wybranych wizytówek. Tylko wybrane etykiety zostaną usunięte. Inne etykiety pozostaną nienaruszone.",
      overwriteLabels: "Ustaw etykiety",
      overwritingLabels: "Ustawiasz etykiety",
      overwriteLabelsQuestion: "Chcesz ustawić (nadpisać) etykiety?",
      overwriteLabelsDescription:
        "Wybierz etykiety, które chcesz ustawić w wybranych wizytówkach. Ta operacja spowoduje, że wszystkie obecne etykiety zostaną usunięte i zastąpione tymi wybranymi przez Ciebie.",
      changeType: "Chcesz jednak zrobić coś innego? Wybierz:",
      changeTypeConfirm:
        "Zmiana sposobu edycji etykiet spowoduje, że wyczyścimy w formularzu do masowej edycji dane, które wprowadziłeś w polu “Etykiety wizytówek”. Wyczyścimy dane tylko w tym formularzu, natomiast w twoich wizytówkach etykiety się nie zmieniają. Czy chcesz kontynuować?",
      dialog: {
        title: "Etykiety",
        description:
          "Poniżej możesz dodawać, usuwać i edytować etykiety dla wybranej wizytówki.",
        noLabels: "Brak etykiet.",
        addLabelBtn: "Dodaj etykietę",
        applyBtn: "Zastosuj"
      }
    },
    moreHours: {
      title: "Więcej godzin",
      facilitiesMoreHours: "Więcej godzin",
      noMoreHoursSelected: "Nie masz wybranych żadnych dodatkowych godzin",
      editMessage: "Ustaw lub usuń dodatkowe godziny, np. godziny dostawy.",
      setMoreHours: "Ustaw dodatkowe godziny",
      setMoreHoursInfo:
        "Ustaw dodatkowe godziny, aby przekazać swoim klientom więcej informacji o Twoich wizytówkach oraz umożliwić im łatwiejsze dotarcie do ważnych źródeł zewnętrznych.",
      settingMoreHours: "Ustawiasz dodatkowe godziny",
      setMoreHoursQuestion: "Chcesz ustawić dodatkowe godziny?",
      setMoreHoursDescription:
        "Podaj nowe dodatkowe godziny, które chcesz ustawić dla wybranych wizytówek. Ta operacja spowoduje, że wszystkie obecne dodatkowe godziny zostaną usunięte i zastąpione tymi wybranymi przez Ciebie.",
      deleteMoreHours: "Usuń dodatkowe godziny",
      deletingMoreHours: "Usuwasz dodatkowe godziny",
      deleteMoreHoursQuestion: "Chcesz usunąć wybrane dodatkowe godziny?",
      deleteMoreHoursDescription:
        "Wybierz godziny, które chcesz usunąć z wybranych wizytówek. Tylko wybrane godziny zostaną usunięte. Inne godziny pozostaną nienaruszone.",
      changeType: "Chcesz jednak zrobić coś innego? Wybierz:",
      changeTypeConfirm:
        "Zmiana sposobu edycji dodatkowych godzin spowoduje, że wyczyścimy w formularzu do masowej edycji dane, które wprowadziłeś w polu “Dodatkowe godziny wizytówek”. Wyczyścimy dane tylko w tym formularzu, natomiast w twoich wizytówkach dodatkowe godziny się nie zmieniają. Czy chcesz kontynuować?",
      categoriesDialog: {
        description:
          "Do informacji na wizytówce, możesz dodać godziny dostępności określonych usług lub ofert.",
        descriptionMassEdit:
          "Do informacji wybranych wizytówek, możesz dodać godziny dostępności określonych usług lub ofert.",
        chooseCategory: "Wybierz kategorię:",
        chooseCategoriesToDelete: "Wybierz kategorie do usunięcia:",
        noCategories: "Brak dostępnych kategorii."
      }
    },
    openStatusDialog: {
      title: "Otwieranie i zamykanie wizytówki"
    },
    addingFacilityToGoogleMapsInProgressInfoText:
      "Nie możesz edytować tej wizytówki, ponieważ jest ona w trakcie dodawania do Map Google."
  },

  facilityCreate: {
    title: "Utwórz wizytówkę",
    cancelCreating: "Anuluj tworzenie",
    baseForm: {
      heading: "Dane wizytówki",
      headingSecondary: "Podaj nazwę i adres wizytówki, którą chcesz dodać.",
      required: "To pole jest wymagane"
    },
    primaryCategoryRequired: "Kategoria podstawowa jest wymagana.",
    accountSelect: {
      heading: "Konto Google",
      headingSecondary:
        "Wybierz konto Google i profil, do którego chcesz dodać nową wizytówkę:",
      noAccounts:
        "Nie można utworzyć wizytówki, ponieważ nie masz dostępnych kont Google"
    },
    createDisabled:
      "Tworzenie nowych wizytówek w Mapach Google z poziomu Center AI jest obecnie wyłączone na Twoim koncie.\nAby włączyć tą funkcję skontaktuj się z pomocą (support@center.ai).",
    dialog: {
      facilityCreated: {
        title: "Wizytówka została dodana do Menedżera Profilu Firmy Google",
        subtitle: "(do konta {account} w profilu {profile})",
        importedToCenter: "oraz została zaimportowana do Center AI.",
        verificationStarted: "Rozpoczęto także proces weryfikacji wizytówki.",
        goToFacilitiesList: "Wróć do listy wizytówek",
        createNew: "Utwórz kolejną wizytówkę"
      },
      facilityImported: {
        description:
          "Import wizytówki został rozpoczęty. W ciągu kilku minut wizytówka będzie widoczna na liście wizytówek w Center AI.",
        goToBtn: "Przejdź do listy wizytówek"
      },
      createDuplicate: {
        title: "Na mapie istnieje już taka wizytówka",
        description: {
          main:
            "Dodanie takiej wizytówki spowoduje, że powstanie jej duplikat. Duplikaty mogą wprowadzać Twoich klientów w błąd. Dodatkowo Google może oznaczyć Twoją wizytówkę jako duplikat (<b>będzie ona wówczas niewidoczna na mapie</b>)."
        },
        sureToContinue: "Czy na pewno chcesz kontynuować?",
        confirmBtn: "Tak, utwórz nową wizytówke na mapie"
      },
      inCenter: {
        title:
          "Wizytówka jest już na Twoim koncie Menedżera Profilu Firmy Google",
        paragraphFirst:
          "Wizytówka o takiej nazwie i adresie jest już dodana do Twojego konta Google (do konta {account} w profilu {profile}) i jest zaimportowana do Center AI.",
        paragraphSecond:
          "Nie ma potrzeby dodawania jej ponownie. Jeśli chcesz zaktualizować dane tej wizytówki przejdź do ekranu edycji.",
        goToEditView: "Przejdź do edycji wizytówki"
      },
      inGoogle: {
        title: "Wizytówka w Mapach Google",
        createNewFacility: "Utwórz nową wizytówkę w Mapach Google",
        choiceHeader:
          "Wybierz wizytówkę, którą chcesz dodać do swojego konta Google:",
        descriptionTop: {
          onlyExistsInAccount:
            "Wizytówka o takiej nazwie i adresie jest już dodana do Twojego konta Google, ale nie została jeszcze zaimportowana do Center AI. Nie ma potrzeby jej tworzenia. Wystarczy ją zaimportować do Center AI.",
          mixWithAndWithoutOwner:
            "Wizytówka o takiej nazwie i adresie istnieje już w Mapach Google, ale nie jest dodana do Twojego konta Google. Pasujące wizytówki, które znaleźliśmy na mapie są na liście poniżej.",
          mixAll:
            "Wizytówka o takiej nazwie i adresie jest już dodana do Twojego konta Google, ale nie została jeszcze zaimportowana do Center AI. Nie ma potrzeby jej tworzenia. Wystarczy ją zaimportować do Center AI. Zauważyliśmy też, że wizytówka o takiej nazwie i adresie istnieje już w Mapach Google, ale nie jest dodana do Twojego konta Google."
        },
        [FACILITY_CREATE_ACTION.EXISTS_IN_ACCOUNT]: {
          text: "Istnieje na Twoim koncie Menedżera Profilu Firmy Google.",
          tooltip:
            "Wizytówka jest już dodana do Twojego konta Google ale nie jest jeszcze zaimportowana do Center AI. Wystarczy zaimportować ją do Center AI. Nie ma potrzeby tworzenia nowej wizytówki.",
          descriptionBottom:
            "Wybrana wizytówka znajduje się na koncie Menedżera Profilu Firmy Google o nazwie {account} w profilu {profile}. Zostanie ona zaimportowana do Center AI w ramach tego konta i profilu.",
          goTo: "Zobacz w Menedżerze Profilu Firmy Google",
          applyBtn: "Zaimportuj"
        },
        [FACILITY_CREATE_ACTION.WITH_OWNER]: {
          text: "Istnieje w Mapach Google. Ma innego właściciela",
          tooltip:
            "Wizytówka, która ma innego właściciela to wizytówka, która została dodana przez inną osobę na mapę i została przez nią zweryfikowana. Ta osoba jest obecnie właścicielem wizytówki i aby przejąć tą wizytówkę na własność będzie potrzbna zgoda tej osoby.",
          goTo: "Zobacz na mapie",
          applyBtn: "Poproś o przejęcie wizytówki",
          tooltipBottom:
            "Po kliknięciu w ten przycisk zobaczysz formularz służący do kontaktu z aktualnym właścicielem wizytówki. W formularzu będzie wyświetlony fragment adresu e-mail tej osoby. Zdarza się, że jest to e-mail kogoś z firmy i wówczas wystarczy skontaktować się z taką osobą bezpośrednio. Jeżeli nie rozpoznajemy adresu e-mail to musimy uzupełnić ten formularz. Google wyśle wtedy informację do obecnego właściciela o naszej próbie. Będzie on miał kilka dni na akceptację lub odrzucenie tej prośby. Jeżeli zostanie ona odrzucona, wówczas można złożyć tzw. “apelację” (można to zrobić w panelu Google (Menedżer Profilu Firmy)). Brak odpowiedzi właściciela w ciągu kilku dni jest równoważny z akceptacją Twojej prośby."
        },
        [FACILITY_CREATE_ACTION.WITHOUT_OWNER]: {
          text: "Istnieje w Mapach Google. Nie ma właściciela",
          tooltip:
            "Wizytówka, która została dodana przez inną osobę na mapę, ale nie została przez nią zweryfikowana. To oznacza, że można tą wizytówkę łatwo dodać do swojego konta i zweryfikować.",
          goTo: "Zobacz na mapie",
          applyBtn: "Dodaj do konta Google"
        }
      }
    }
  },

  facilitiesEdit: {
    editSuccess: "Edycja zakończona powodzeniem",
    bulkEditMessage:
      "Masowa edycja wizytówek jest w trakcie wykonywania. Do momentu jej zakończenia nie możesz wprowadzać nowych masowych zmian.",
    title: "Edycja masowa wizytówek",
    checkFieldsDescription:
      "Zaznacz pola, które chcesz zaktualizować i wprowadź nowe dane. Dane zostaną zaktualizowane we wszystkich wybranych wizytówkach."
  },

  facilitiesAddNew: {
    addExistingFacilities: "Dodaj istniejące wizytówki",
    importFromGoogleMyBusiness: "Zaimportuj z Menedżera Profilu Firmy Google",
    importFromGoogleMyBusinessDescription:
      "Zaloguj się na konto Google i wybierz wizytówki, które chcesz dodać. Dane zostaną automatycznie pobrane.",
    analysisPositionAtGoogleMaps: "Analiza pozycji w Mapach Google",
    comparingWithCommercialFacilities:
      "Porównanie z konkurencyjnymi wizytówkami",
    updateDataOnGoogleMaps: "Aktualizacja danych w Mapach Google",
    updateDataOnOtherMaps: "Aktualizacja danych na innych mapach",
    accessToStatistics:
      "Dostęp do statystyk dotyczących wyszukiwań wizytówki i zachowań użytkowników w Mapach Google",
    searchOnGoogleMaps: "Wyszukaj w Mapach Google",
    searchOnGoogleMapsDescription:
      "Wyszukaj wizytówkę w Mapach Google podając jej adres lub nazwę. Publicznie dostępne dane zostaną automatycznie pobrane",
    addFacilitySearchingOnTheMap:
      "Dodaj wizytówkę szukając jej w Mapach Google",
    addFacilitySearchingOnTheMapDescription:
      "Wyszukaj wizytówkę w Mapach Google podając jej adres lub nazwę w polu poniżej. Publicznie dostępne dane zostaną automatycznie pobrane.",
    noAccess: "Nie masz uprawnień do dodawania wizytówek"
  },

  wizard: {
    addNameAndchooseFromList: "Wpisz nazwę i wybierz z listy",
    streetAndHomeNumber: "Ulica i numer domu/mieszkania",
    websitesAndSocialMedia: "Strony www & Social media",
    websitesAlertInfo: "Dodaj przynajmniej jedną wizytówkę, lub stronę www",
    websitesInfoHint:
      "Dodaj domenę bez podstron. Dzięki temu będziemy monitorować pozycję całej domeny oraz wszystkich jej podstron.",
    fillTaxNumber: "Wypełnij pole NIP",
    taxNumberFieldDescription:
      "Podaj numer NIP aby automatycznie odczytać informacje o firmie i szybciej skonfigurować konto.",

    businessAddresses: {
      method: {
        title: "Dodaj swoje wizytówki z Map Google",
        description:
          "Dodaj konto Google, aby automatycznie pobrać wszystkie Twoje wizytówki w Mapach Google",
        addManually: "Dodaj wizytówki ręcznie"
      }
    },

    companyInWeb: {
      name: "Twoja firma w internecie",
      header: "Jak znajdują Cię w internecie Twoi klienci?",
      termsTitle: "Czego szukają Twoi klienci?",
      termsDescription:
        "Hasła, które wpisują ludzie w wyszukiwarkach internetowych takich jak Google i w Mapach Google, aby znaleźć Ciebie lub podobne firmy.",
      localityTitle: "Gdzie są Twoi klienci?",
      localityDescription:
        "W jakich miastach i lokalizacjach są Twoi potencjalni klienci?",
      settingsTitle: "Co chciałbyś żeby znaleźli klienci?",
      settingsDescription:
        "Wybierz z listy wizytówkę lub stronę www dla której chcesz określić parametry.",
      suggestedAll: "Dodaj do wszystkich wizytówek i stron www",
      suggestedWebsites: "Dodaj do wszystkich stron www",
      facilitiesAll: "Dodaj hasło do wszystkich wizytówek",
      facilitiesSelected: "Dodaj hasło tylko do wizytówki wybranej powyżej",
      removeLabel:
        "Usunąć słowo tylko z wybranej wizytówki czy ze wszystkich wizytówek?",
      facilitiesRemoveAll: "Usuń ze wszystkich",
      facilitiesRemoveSelected: "Usuń z wybranej",
      businessAddress: "wizytówka",
      noAddressesSelected:
        "Nie dodano wizytówek. Aby przejść dalej dodaj przynajmniej jedną wizytówkę.",
      inLocationVicinity: "w pobliżu placówek"
    },

    validation: {
      companyNotFound:
        "Dla podanego numeru NIP nie udało się pobrać danych firmy. Zweryfikuj czy podany numer NIP jest prawidłowy."
    }
  },

  average: {
    veryWeak: "Bardzo słaba",
    weak: "Słaba",
    medium: "Średnia",
    good: "Dobra",
    veryGood: "Bardzo dobra"
  },

  error: {
    badRequest:
      "Nieprawidłowe zapytanie. Skontaktuj się z naszym działem wsparcia.",
    unauthorized: "Dostęp wymaga uwierzytelnienia. Zaloguj się do panelu.",
    notFound:
      "Nie znaleziono żądanego zasobu. Skontaktuj się z naszym działem wsparcia.",
    server: "Błąd serwera. Skontaktuj się z naszym działem wsparcia.",
    other: "Wystąpił błąd. Skontaktuj się z naszym działem wsparcia.",
    parsing: "Błąd podczas parsowania danych",
    requiredField: "To pole jest wymagane",
    noAccounts: "Brak dodanych kont"
  },

  businessAddresses: {
    list: {
      facilityIs: "Wizytówka jest",
      isDuplicate: "duplikatem",
      isDisconnected: "odłączona",
      editTooltip:
        "W tym miejscu możesz szybko edytować wiele wizytówek jednocześnie. Wybierz więcej niż 1 wizytówkę i przejdź do edycji zbiorczej.",
      tabTitle: "Lista wizytówek",
      searchPlaceholder: "Nazwa, adres, kod sklepu",
      delete: "Odłącz od Center AI",
      addingToGoogleMaps: "W trakcie dodawania do Map Google",
      totalFacilitiesCount: "Wszystkich wizytówek: {0}",
      ignoreUnverifiedFacilities: "Ignoruj niezweryfikowane wizytówki"
    },
    groups: {
      tabTitle: "Grupy wizytówek",
      noGroups: {
        description:
          "Twórz grupy, dodawaj do nich wizytówki i ułatw sobie zarządzanie informacjami!",
        button: "Dodaj nową grupę"
      },
      labelGroups: {
        addBtn: "Dodaj nową grupę z etykiet GMB",
        labelGroupListItemTooltip: "Powiązana z etykietami GMB",
        labelGroupTooltip:
          "Ta grupa jest automatycznie zarządzana przez system Center AI, tzn. system będzie dodawał lub usuwał wizytówki z tej grupy na podstawie zmian w etykietach wizytówek. Listy wizytówek w tej grupie nie można edytować manualnie.",
        addGroupDialog: {
          title: "Wybierz etykiety",
          description:
            "Wybierz etykiety, na podstawie których chcesz utworzyć grupę wizytówek. Wszystkie wizytówki posiadające wszystkie z wybranych etykiet zostaną dodane do tej grupy. Grupa będzie automatycznie zarządzana przez system Center AI, tzn. system będzie dodawał lub usuwał wizytówki z tej grupy na podstawie zmian w etykietach wizytówek."
        }
      },
      groupNotSelected: "Nie wybrano grupy",

      addNewGroup: {
        title: "Dodaj grupę",
        chosenCompany: "Wybrana firma: {0}",
        newGroupName: "Nazwa grupy",
        successfullyAdded: 'Pomyślnie utworzono grupę "{0}"'
      },

      editGroup: {
        title: "Edytuj nazwę grupy",
        chosenCompany: "Wybrana firma: {0}",
        newGroupName: "Nazwa grupy",
        successfullyUpdated: "Pomyślnie edytowano grupę"
      },

      emptyGroup:
        "Dodaj wizytówki do grupy, aby ułatwić sobie zarządzanie informacjami",
      createdGroups: "Utworzone grupy:",
      groupSuccessfullyDeleted: 'Pomyślnie usunięto grupę "{0}"',

      facilities: {
        facilitiesInGroup: "Wizytówki w tej grupie",
        addFacilitiesButton: "Dodaj wizytówki",
        emptyGroup:
          "Dodaj wizytówki do grupy, aby ułatwić sobie zarządzanie informacjami",
        filterInputPlaceholder: "Jakiej wizytówki szukasz?",
        noFacilitiesMatchingQuery:
          "Nie znaleziono żadnych wizytówek pasujących do wyszukiwania",
        addFacilitiesToGroup: "Dodaj wizytówki do grupy",
        selectedGroup: "Wybrana grupa: {0}",
        facilitiesAdded: 'Wizytówki zostały dodane do grupy "{0}"',
        facilityDeleted: 'Wizytówka "{0}" została usunięta z grupy "{1}"',
        facilitiesDeleted: 'Wizytówki zostały usunięte z grupy "{0}"'
      }
    },
    quality: {
      viewTitle: "Jakość wizytówek w Mapach Google",
      actionButtons: {
        information: {
          add: {
            text:
              "Uzupełnij informacje w twojej wizytówce, aby klienci widzieli aktualne dane.",
            label: "Uzupełnij informacje"
          },
          edit: {
            text:
              "Edytuj informacje w twojej wizytówce, aby klienci widzieli aktualne dane.",
            label: "Edytuj informacje"
          }
        },
        reviews: {
          text: "Zadbaj o swoich klientów odpowiadając na ich opinie.",
          label: "Odpowiedz klientom"
        },
        photos: {
          text: "Dodaj zdjęcia i pokaż się klientom z dobrej strony.",
          label: "Dodaj zdjęcia"
        },
        posts: {
          text:
            "Dodaj wpisy, aby poinformować klientów o promocjach i aktualnościach.",
          label: "Dodaj wpisy"
        }
      }
    }
  },

  externalChanges: {
    title: "Zmiany zewnętrzne",
    hasExternalChanges:
      "Ta wizytówka ma zmiany zewnętrzne oczekujące na akceptację lub odrzucenie",
    noChanges:
      "Monitorujemy sugerowane zmiany w Twoich wizytówkach. Aktualnie nie masz żadnych nowy zmian lub zostały one odrzucone/zaakceptowane przez włączoną ochronę.",
    noChangesHistory: "Aktualnie Twoja historia zmian jest pusta.",
    noChangesAlt: "Brak zmian zewnętrznych.",
    automaticChange: "Ochrona Center AI",
    list: {
      title: "Zmiany zewnętrzne",
      searchPlaceholder: "Nazwa, adres, kod wizytówki",
      overLimitTooltip:
        "Masowe akcje możesz wykonać dla maksymalnie {count} wizytówek."
    },
    protect: {
      title: "Ochrona przed zmianami zewnętrznymi",
      description:
        "W ramach ochrony wizytówek w Mapach Google możesz skonfigurować w jaki sposób chcesz reagować na zmiany informacji w Twoich wizytówkach wykonane poza Center AI. Zrobisz to wskazując jaką akcję (akceptacja lub odrzucenie) chcesz wykonać, gdy zostaną wykryte zmiany poszczególnych informacji. Część z tych akcji Center AI wykona za Ciebie, jednak w przypadku odrzucania zmian będzie potrzebne Twoje potwierdzenie.",
      type: {
        external: "Zmiany zewnętrzne",
        gmb: "Zmiany w Menedżerze Profilu Firmy Google"
      },
      alwaysAccept: "Akceptuj",
      alwaysReject: "Odrzucaj",
      allFields: "Wszystkie pola",
      infoDialog: {
        title: "Ustawienia zapisane",
        textContentFirst:
          "Twoje wizytówki będą monitorowane zgodnie z konfiguracją w poszukiwaniu zmian informacji wykonanych poza Center AI. Gdy zostaną wykryte zmiany, które chcesz odrzucać dostaniesz powiadomienie z prośbą o zatwierdzenie odrzucenia tych zmian. Natomiast gdy zostaną wykryte zmiany, które chcesz akceptować zostaną one obsłużone przez system (w tym przypadku nie jest wymagane Twoje działanie).",
        showChangesBtn: "Zobacz zmiany wykryte wcześniej"
      }
    },
    history: {
      title: "Historia zmian",
      searchPlaceholder: "Nazwa, adres, kod wizytówki",
      changeHeaderTooltip:
        "Zmiana danych, która została wykonana, zaakceptowana lub odrzucona.",
      showAllChanges: "Zobacz wszystkie zmiany ({count})"
    },
    date: "Data",
    origin: "Źródło zmiany",
    type: "Typ zmiany",
    user: "Użytkownik",
    field: "Zmienione pole",
    change: "Zmiana",
    allChanges: "Wszystkich zmian: {count}",
    action: "Akcja",
    actionPerformed: "Wykonanie akcji",
    changeDetected: "Wykrycie zmiany",
    additionTooltip: "Dodanie nowych informacji.",
    removalTooltip: "Usunięcie istniejących informacji.",
    changeTooltip: "Zmiana istniejących informacji.",
    selectedFacilities: "Zaznaczonych wizytówek: {0}",
    groupChangeDialog: {
      [EXTERNAL_CHANGES_STATUS.ACCEPTED]: {
        title: "Akceptacja zmian zewnętrznych",
        text:
          "Wybierz zmiany, które chcesz zaakceptować we wszystkich wybranych wizytówkach.",
        button: "Akceptuj",
        [EXTERNAL_CHANGES_SOURCE.GMB]:
          "Akceptujesz tylko zmiany pochodzące z Menedżera Profilu Firmy Google",
        [EXTERNAL_CHANGES_SOURCE.EXTERNAL]:
          "Akceptujesz tylko zmiany pochodzenia zewnętrznego"
      },
      [EXTERNAL_CHANGES_STATUS.REJECTED]: {
        title: "Odrzucanie zmian zewnętrznych",
        text:
          "Wybierz zmiany, które chcesz odrzucić we wszystkich wybranych wizytówkach.",
        button: "Odrzuć",
        [EXTERNAL_CHANGES_SOURCE.GMB]:
          "Odrzucasz tylko zmiany pochodzące z Menedżera Profilu Firmy Google",
        [EXTERNAL_CHANGES_SOURCE.EXTERNAL]:
          "Odrzucasz tylko zmiany pochodzenia zewnętrznego"
      }
    },
    informationalFieldTooltip:
      "Zmienił się status wizytówki. Tej zmiany nie możesz odrzucić.",
    processingInProgressTooltip:
      "Center AI aktualizuje obecnie informacje tej wizytówki w Mapach Google. Podczas tej aktualizacji chwilowo nie można wykonywać dodatkowych zmian w tej wizytówce. Spróbuj ponownie za kilka minut.",
    fields: {
      [EXTERNAL_CHANGES_FIELD.NAME]: "Nazwa wizytówki",
      [EXTERNAL_CHANGES_FIELD.STREET]: "Ulica",
      [EXTERNAL_CHANGES_FIELD.POSTAL_CODE]: "Kod pocztowy",
      [EXTERNAL_CHANGES_FIELD.CITY]: "Miasto",
      [EXTERNAL_CHANGES_FIELD.COUNTRY]: "Kraj",
      [EXTERNAL_CHANGES_FIELD.STORE_CODE]: "Kod sklepu",
      [EXTERNAL_CHANGES_FIELD.PRIMARY_CATEGORY]:
        "Podstawowa kategoria działalności",
      [EXTERNAL_CHANGES_FIELD.ADDITIONAL_CATEGORIES]:
        "Dodatkowe kategorie działalności",
      [EXTERNAL_CHANGES_FIELD.WEBSITE]: "Adres strony www",
      [EXTERNAL_CHANGES_FIELD.PRIMARY_PHONE]: "Numer telefonu 1",
      [EXTERNAL_CHANGES_FIELD.ADDITIONAL_PHONES]: "Numer telefonu 2",
      [EXTERNAL_CHANGES_FIELD.REGULAR_HOURS]: "Godziny otwarcia",
      [EXTERNAL_CHANGES_FIELD.SPECIAL_HOURS]: "Niestandardowe godziny otwarcia",
      [EXTERNAL_CHANGES_FIELD.ATTRIBUTES]: "Atrybuty",
      [EXTERNAL_CHANGES_FIELD.DESCRIPTION]: "Opis",
      [EXTERNAL_CHANGES_FIELD.OPENING_DATE]: "Data otwarcia",
      [EXTERNAL_CHANGES_FIELD.LOCATION_STATE]:
        "Status w Menedżerze Profilu Firmy Google",
      [EXTERNAL_CHANGES_FIELD.OPEN_STATUS]: "Status otwarcia wizytówki",
      [EXTERNAL_CHANGES_FIELD.LABELS]: "Etykiety",
      [EXTERNAL_CHANGES_FIELD.MORE_HOURS]: "Więcej godzin",
      [EXTERNAL_CHANGES_FIELD.SERVICES]: "Usługi"
    },
    fieldsTooltips: {
      [EXTERNAL_CHANGES_FIELD.REGULAR_HOURS]:
        "Godziny otwarcia oraz dodatkowe godziny (np. godziny dostawy)"
    },
    summaryInfoBar:
      "W ramach ochrony wizytówek wykryto {changesCount} do odrzucenia zgodnie z Twoją konfiguracją.",
    rejectChanges: "Odrzuć zmiany",
    changesInfoSection: {
      detectedChanges:
        "Wykryliśmy {changesCount} do odrzucenia (w {facilitiesCount}) dotyczących pól, które chcesz chronić.",
      changesRelatedTo: "Zmiany dotyczą takich pól: {fields}.",
      availableHere: "Lista wszystkich wykrytych zmian dostępna jest {link}.",
      here: "tutaj",
      confirmReject: "Potwierdź jednym kliknięciem odrzucenie wykrytych zmian.",
      noChanges:
        "Nie wykryliśmy żadnych zmian do odrzucenia dotyczących pól, które chcesz chronić.",
      rejectingDialog: "Zmiany są w trakcie odrzucania.",
      rejectDetectedChanges: "Odrzuć wykryte zmiany",
      rejectConfirmation: "Czy na pewno chcesz odrzucić wykryte zmiany?"
    }
  },

  photos: {
    title: "Dodaj zdjęcie",
    facilityLabel: "Zdjęcie zostanie dodane do",
    facilitiesAll: "wszystkich wizytówek (zweryfikowanych)",
    facilitiesAllTooltip:
      "Zdjęcia mogą zostać wysłane tylko do wizytówek, które są zweryfikowane w Mapach Google.",
    facilitiesSelected: "wybranych wizytówek (zweryfikowanych)",
    facilitiesSelectedTooltip:
      "Zdjęcia mogą zostać wysłane tylko do wizytówek, które są zweryfikowane w Mapach Google. Na liście wizytówek do wyboru znajdują się tylko takie wizytówki.",
    addPhotoTitle: "Zdjęcie",
    addPhotoTooltip:
      'Minimalne zalecane wymiary: <b>720 x 720</b> pikseli.<br/> Rozmiar pliku: od <b>10 KB</b> do <b>10 MB</b>.<br/> Zdjęcia w kategorii "<b>Okładka</b>" muszą mieć proporcje 16:9.',
    addPhoto: "Dodaj zdjęcie",
    changePhoto: "Zmień zdjęcie",
    categoriesTooltip:
      'Kategoria, w której będzie wyświetlane zdjęcie w Mapach Google. Niektóre kategorie (np. Żywność i napoje) mogą być niedostępne dla niektórych firm. W przypadku wysłania zdjęcia w kategorii, która jest niedostępna, zdjęcie zostanie automatycznie dodane do kategorii "Inne".',
    send: "Opublikuj",
    addMore: "Dodaj więcej zdjęć",
    photoAddedSuccessfully:
      "Zdjęcia zostały przesłane. Będą one widoczne w Mapach Google w ciągu 10 minut.",
    photosNotAdded:
      "Nie udało się dodać wszystkich zdjęć. Spróbuj wysłać ponownie pozostałe zdjęcia.",
    facilitiesError: "Wymagana przynajmniej jedna wizytówka",
    countLimitError: 'Można wysłać tylko jedno zdjęcie w kategorii "{0}"',
    edit: {
      applyChanges: "Zachowaj zmiany",
      infoBox: "Chwyć za rogi i przycinaj zdjęcie według uznania.",
      rotateRight: "Obróć w prawo",
      rotateLeft: "Obróć w lewo",
      reset: "Resetuj"
    },
    noData: {
      button: "Dodaj konto",
      title: "Dodawaj zdjęcia do wizytówek w Mapach Google",
      desc:
        "Tutaj możesz dodawać zdjęcia do wszystkich lub wybranych wizytówek w Mapach Google. Dzięki temu zaoszczędzisz dużo czasu i pracy. Aby było to możliwe zaimportuj Twoje wizytówki dodając konto Google."
    },
    list: {
      title: "Wysłane zdjęcia",
      empty: "Dodawaj zdjęcia do swoich wizytówek.",
      notFound: "Brak zdjęć w wybranym okresie.",
      noPhotos: "Brak zdjęć",
      addNew: "Dodaj nowe",
      sendDate: "Data wysłania",
      mapsStatus: "Status zdjęcia w Mapach Google",
      slStatus: "Status zdjęcia w Store Locator",
      sendStatus: "Status",
      details: "Szczegóły",
      visible: "Zdjęcie widoczne",
      sendToFacilities: "Zdjęcie wysłane do {0}",
      successCount: "{0} opublikowano",
      failedCount: "{0} odrzucono",
      [GMB_MEDIA_TYPE.ADDITIONAL.NAME]: "Inne",
      [GMB_MEDIA_TYPE.COVER.NAME]: "Okładka",
      [GMB_MEDIA_TYPE.LOGO.NAME]: "Logo",
      [GMB_MEDIA_TYPE.EXTERIOR.NAME]: "Z zewnątrz",
      [GMB_MEDIA_TYPE.INTERIOR.NAME]: "Wnętrze",
      [GMB_MEDIA_TYPE.PRODUCT.NAME]: "Produkt",
      [GMB_MEDIA_TYPE.FOOD_AND_DRINK.NAME]: "Żywność i napoje",
      [GMB_MEDIA_TYPE.TEAMS.NAME]: "Zespół",
      delete: {
        title:
          "Czy na pewno chcesz usunąć wybrane zdjęcie ze wszystkich wizytówek?",
        body1:
          "Ta akcja spowoduje usunięcie zdjęć w Menedżerze Profilu Firmy Google. Zdarza się, że usunięte zdjęcia są jeszcze przez jakis czas widoczne w Mapach Google (są usuwane przez Google z opóźnieniem). Wynika to ze sposobu działania algorytmów Google i nie ma na to wpływu czy wpis zostanie usunięty przez Center AI czy bezpośrednio w panelu Google (Menedżer Profilu Firmy). Taka sytuacja występuje na szczęście rzadko.",
        body2:
          "Usunięcie zdjęcia spowoduje brak dalszego wyświetlania go w Store Locator.",
        confirm: "Tak, usuń",
        tooltip:
          "Aby usunąć to zdjęcie skontaktuj się z nami mailowo (support@center.ai) lub na czacie."
      },
      status: {
        [GMB_MEDIA_STATUS.PENDING]: "W trakcie wysyłania",
        [GMB_MEDIA_STATUS.COMPLETED]: "Wysyłanie zakończone",
        [GMB_MEDIA_STATUS.FINISHED_WITH_PROBLEMS]: "Wysyłanie zakończone"
      }
    },
    storeLocator: {
      tooltipSwitchOff:
        "Dodawane zdjecie nie będzie widoczne w Store Locator. Widoczność zdjęcia możesz zmienić także, już po jego dodaniu.",
      tooltipSwitchOn:
        "Dodawane zdjecie będzie widoczne w Store Locator. Widoczność zdjęcia możesz zmienić także, już po jego dodaniu."
    }
  },

  posts: {
    fbDialogTitle: "Kopiowanie wpisu z Facebooka",
    copyFacebookPost: "Skopiuj wpis z Facebooka",
    usedForGoogleMapsPost: "Wykorzystano do stworzenia wpisu w Google Maps",
    selectPage: "Wybierz page",
    selectPost: "Wybierz wpis",
    multimedia: "Multimedia",
    checkOriginalPost: "Przejdź do oryginalnego wpisu",
    planning: {
      authorAndDate: "Autor i data utworzenia",
      postsFrom: "Wpisy z dnia",
      showAllPlannedPosts: "Pokaż wszystkie zaplanowane wpisy",
      facilitiesSendTooltip:
        "Wpis zostanie wysłany tylko do wizytówek, które były w wybranych {0} w momencie planowania wpisu. Wizytówki, które pojawiły się w tych {0} później nie zostaną uwzględnione. Dodatkowo, jeżeli do momentu wysyłki stracisz uprawnienia do niektórych wizytówek to wpis nie zostanie do nich wysłany.",
      actionsDisabledTooltip:
        "Nie masz uprawnień do edycji tego wpisu. Skontaktuj się z autorem / adminem.",
      info:
        "Wpis zostanie wysłany tylko do wizytówek, które były w wybranych {0} w momencie planowania wpisu.",
      cities: "miastach",
      groups: "grupach",
      addPostTo: "Wpis dodadasz do",
      emptyText: "Nie masz żadnych zaplanowanych wpisów.",
      publication: {
        publicationDateTitle: "Data publikacji wpisu",
        publicationDateSubtitle: "Wybierz datę i godzinę publikacji wpisu.",
        now: "Teraz",
        tomorrowMorning: "Jutro rano",
        nextWeek: "Za tydzień",
        anotherDate: "Inna data"
      }
    },
    scheduledSending: "Wysyłanie zaplanowane",
    sent: "Wysłane",
    list: {
      planned: "Zaplanowane",
      [POSTS_FORM_TYPE.POST]: "Wpis",
      [POSTS_FORM_TYPE.EVENT]: "Wydarzenie",
      [POSTS_FORM_TYPE.OFFER]: "Oferta",
      [POSTS_FORM_TYPE.ALERT]: "COVID-19",
      titleTooltip:
        "Na tym ekranie widzisz listę wpisów, które zostały wysłane z Center AI. Lista nie zawiera wpisów, które były wysłane spoza Center AI, np. z panelu Google (Menedżer Profilu Firmy).",
      searchFieldPlaceholder: "Szukaj wpisu",
      toogleShowDeletedPosts: "Pokaż usunięte wpisy",
      noPostsAlt: "Brak wpisów",
      noPostsDescription:
        "W wybranym okresie nie masz jeszcze żadnych opublikowanych wpisów w wizytówkach. \nDodaj wpis do wszystkich lub wybranych wizytówek, aby zachęcić klientów do wizyty oraz pozycjonować wizytówki w wynikach wyszukiwania w Mapach Google.",
      noPhoto: "brak zdjęcia",
      clickInButton: 'w przycisk: "{label}"',
      sendingInProgress: "W trakcie wysyłania do",
      sendingFinished: "Wysyłanie zakończone",
      deletingInProgress: "W trakcie usuwania",
      creatingInProgress: "W trakcie wysyłania",
      deleted: "Usunięto",
      sentTo: "Wpis wysłany do",
      sentDate: "Data wysłania",
      editDate: "Data edycji",
      deleteDate: "Data usunięcia",
      detailsStatusSent: "Wysłano {sent_count}/{total_count}",
      sentSuccessCount: "{count} opublikowano",
      sentErrorCount: "{count} odrzucono",
      durationTime: "Czas obowiązywania",
      confirmPlannedDeleteDialog: {
        text: "Czy na pewno chcesz usunąć zaplanowany wpis?"
      },
      confirmDeleteDialog: {
        text:
          "Czy na pewno chcesz usunąć wybrany wpis ze wszystkich wizytówek?",
        description:
          "Ta akcja spowoduje usunięcie wpisów w Menedżerze Profilu Firmy Google. Zdarza się, że usunięte wpisy są jeszcze przez jakiś czas widoczne w Mapach Google (są usuwane przez Google z opóźnieniem). Wynika to ze sposobu działania algorytmów Google i nie ma na to wpływu czy wpis zostanie usunięty przez Center AI czy bezpośrednio w panelu Google (Menedżer Profilu Firmy). Taka sytuacja występuje na szczęście rzadko."
      },
      facilitiesDialog: {
        defaultTitle: "Wpis wysłano do poniższych wizytówek",
        [POST_BY_FACILITY_STATUS.OK]: {
          title: "Wpis wysłano do poniższych wizytówek"
        },
        [POST_BY_FACILITY_STATUS.FAILED]: {
          title: "Nie wysłano wpisu do poniższych wizytówek"
        },
        fixError: {
          general: "Skontaktuj się z nami"
        }
      }
    },
    add: {
      [POSTS_FORM_TYPE.POST]: "Dodaj wpis",
      [POSTS_FORM_TYPE.EVENT]: "Dodaj wydarzenie",
      [POSTS_FORM_TYPE.OFFER]: "Dodaj ofertę",
      [POSTS_FORM_TYPE.ALERT]: "COVID-19 poinformuj"
    },
    // Add new post related texts below
    addEvent: "",
    addOffer: "",
    addTime: "Dodaj godzinę",
    alertHeader: "Poinformuj klientów",
    facilityLabel: "Wpisy zostaną dodane do",
    facilitiesAll: "wszystkich wizytówek (zweryfikowanych)",
    facilitiesAllUnverified: "wszystkich wizytówek",
    facilitiesAllTooltip:
      "Wpisy mogą zostać wysłane tylko do wizytówek, które są zweryfikowane w Mapach Google.",
    facilitiesSelected: "wybranych wizytówek (zweryfikowanych)",
    facilitiesSelectedUnverified: "wybranych wizytówek",
    facilitiesSelectedTooltip:
      "Wpisy mogą zostać wysłane tylko do wizytówek, które są zweryfikowane w Mapach Google. Na liście wizytówek do wyboru znajdują się tylko takie wizytówki.",
    mainPhoto: "Zdjęcie główne",
    offerName: "Nazwa oferty",
    postName: "Treść wpisu",
    eventName: "Nazwa wydarzenia",
    alertName: "Daj znać o zmianach",
    startDate: "Data rozpoczęcia",
    endDate: "Data zakończenia",
    startTime: "Godzina rozpoczęcia",
    endTime: "Godzina zakończenia",
    offerDetails: "Szczegóły oferty",
    offerCode: "Kupon rabatowy (opcjonalnie)",
    offerLink: "Link do oferty (opcjonalnie)",
    offerTerms: "Warunki (opcjonalnie)",
    showExtra: "Dodaj więcej informacji (opcjonalnie)",
    publish: "Opublikuj",
    publishFor: "Opublikuj dla {0}",
    preview: "Podgląd",
    schedule: "Szczegóły wydarzenia",
    postUrl: "Link",
    callToAction: {
      label: "Dodaj przycisk (opcjonalnie)",
      [POSTS_CALL_TO_ACTION_TYPE.BOOK]: "Zarezerwuj",
      [POSTS_CALL_TO_ACTION_TYPE.ORDER]: "Zamów online",
      [POSTS_CALL_TO_ACTION_TYPE.SHOP]: "Kup",
      [POSTS_CALL_TO_ACTION_TYPE.LEARN_MORE]: "Więcej informacji",
      [POSTS_CALL_TO_ACTION_TYPE.SIGN_UP]: "Zarejestruj się",
      [POSTS_CALL_TO_ACTION_TYPE.CALL]: "Zadzwoń teraz"
    },
    alertTitle: "Czy w Twojej firmie zaszły jakieś zmiany?",
    alertSubtitle:
      "Powiadom swoich klientów co zmieniło się w Twojej firmie w związku z koronawirusem",
    noData: {
      button: "Dodaj konto",
      title: "Dodawaj wpisy do wizytówek w Mapach Google",
      desc:
        "Tutaj możesz dodawać wpisy do profili wszystkich Twoich wizytówek w Mapach Google. Wystarczy, że podasz treść wpisu tylko raz a my automatycznie wyślemy go do wszystkich lub wybranych wizytówek. Dzięki temu zaoszczędzić dużo czasu i pracy. Aby było to możliwe zaimportuj Twoje wizytówki dodając konto Google."
    },
    addImage: "Dodaj zdjęcie",
    addImageTooltip:
      "Zdjęcie powinno być w formacie PNG lub JPG. Zalecane proporcje zdjęcia to 4:3. Minimalne wymiary zdjęcia to 400 x 300 pikseli i rozmiar 10 kB. Maksymalne zalecane wymiary zdjęcia to 8000 x 6000 pikseli i rozmiar 10 MB.",
    postSuccess:
      "Wpis został przesłany. Będzie on wkrótce widoczny w Mapach Google.",
    postPlannedSuccess:
      "Wpis został przesłany. Będzie on opublikowany w Mapach Google {0}.",
    select: "Wybierz",
    facilitiesError: "Wymagana przynajmniej jedna wizytówka",
    published: "Opublikowano",
    selectedFacilities: "Wybrano {facilitiesCount}",
    selectedCities: "Wybrano {citiesCount} ({facilitiesCount})",
    selectedFacilitiesGroups:
      "Wybrano {facilitiesGroupsCount} ({facilitiesCount})",
    changeButton: "Zmień",
    viewButton: "Zobacz",
    facilitiesToAddDialog: {
      title: "Wpis zostanie wysłany do poniższych wizytówek",
      noFacilities: "Nie wybrano żadnych wizytówek"
    },
    successfullyDeleted: "Post został usunięty.",
    postsGuideBtn: "Wpisy - poradnik",
    storeLocator: {
      visibilityStatus: "Status wpisu w Store Locator",
      tooltipSwitchOff:
        "Dodawany wpis nie będzie widoczny w Store Locator. Widoczność wpisu możesz zmienić także, już po jego dodaniu.",
      tooltipSwitchOn:
        "Dodawany wpis będzie widoczny w Store Locator. Widoczność wpisu możesz zmienić także, już po jego dodaniu."
    },
    postVisibility: "Wpis widoczny",
    visibleGoogleMaps: "W Mapach Google",
    visibleStoreLocator: "W Store Locator"
  },

  reviews: {
    cannotEditOptimisticReply:
      "Przetwarzamy Twoją odpowiedź. Edycja będzie możliwa za chwilę.",
    cannotDeleteOptimisticReply:
      "Przetwarzamy Twoją odpowiedź. Usunięcie będzie możliwe za chwilę.",
    aiReply: {
      packetCloseToLimitTooltip:
        "W celu zwiększenia pakietu skontaktuj się z nami",
      onlyTextTooltip: "Funkcja dostępna tylko dla opinii z tekstem",
      outOfLimitTooltip:
        "W tym miesiącu nie można już wygenerować odpowiedzi z pomocą AI, ponieważ wykorzystano dostępny pakiet. Pakiet odnowi się na początku miesiąca. Aby zwiększyć pakiet skontaktuj się z nami.",
      error: "Błąd odpowiedzi z AI",
      replyWithAi: "Odpowiedz z AI",
      generateAgain: "Generuj ponownie",
      repliesLeft: "Pozostało odpowiedzi",
      generateWithAi: "Generowanie odpowiedzi z AI",
      settingsAiReply: "Ustawienia odpowiedzi z AI",
      instructionsForAi: "Instrukcje dla AI",
      aiSettingsTip1:
        "Jak to działa: Tutaj możesz opcjonalnie wpisać dodatkowe instrukcje, które AI wykorzysta podczas tworzenia propozycji odpowiedzi na opinie. Instrukcje mogą dotyczyć dowolnego aspektu np. stylu wypowiedzi, użycia konkretnych słów lub zdań. Poniżej znajduje się przykład takich instrukcji.",
      aiSettingsTip2:
        'Przykład: Używaj formalnego języka, ale zwracaj się do autora opinii na Ty. Na końcu zawsze dodawaj zdanie: "Dziękujemy za zakupy w naszym sklepie! Zapraszamy ponownie!"'
    },
    periods: {
      weekly: "Tygodniowo",
      monthly: "Miesięcznie"
    },
    chart: {
      averageRateForCategory:
        "Średnia ocena w kategorii “{0}” w wybranym okresie",
      reviewsCountForCategory:
        "Liczba opinii w kategorii “{0}” w wybranym okresie",
      sentimentRateForCategory:
        "Sentyment ocen w kategorii “{0}” w wybranym okresie"
    },
    dialogs: {
      howDoesAutomaticCategorizationWork:
        "Jak działa automatyczna kategoryzacja opinii?",
      contact: "Kontakt",
      autoCategorizeOldReviews:
        "Po włączeniu automatycznej kategoryzacji kategorie są przypisywane jedynie do nowych opinii (tych, które pojawią się w przyszłości). Jeżeli chcesz automatycznie skategoryzować także starsze opinie skontaktuj się z nami.",
      addPhrasesToCategoryTitle: "Dodaj frazy do kategorii",
      addPhrasesToCategoryContent: `Dodaj frazy do kategorii (np. “drogo” do kategorii Cena). Dzięki temu
      system będzie mógł automatycznie przypisywać tę kategorię do opinii.`,
      alertBeforeActionFirstLine: `Wprowadziłeś/aś następujące zmiany w ramach kategorii “{0}”:`,
      alertBeforeActionLastLine: `Czy na pewno chcesz zapisać zmiany? Spowodują one zmiany w istniejących i przyszłych opiniach zawierających następujące frazy.`,
      autoCategorizationTitle: `Automatyczna kategoryzacja opinii i określanie sentymentu`,
      autoCategorizationContent: `Center AI może automatycznie przypisywać kategorie (np. "obsługa klienta") do każdej opinii, która ich dotyczy. 
      Odbywa się to przez analizę treści opinii.
      Dodatkowo dla każdej wykrytej kategorii określany jest jej sentyment czyli
      nastawienie emocjonalne (sentyment pozytywny, neutralny, negatywny).
      <br /><br />
      Żeby skorzystać z automatycznego określania kategorii i ich sentymentu
      należy jedynie:<br /><br />
      - Zdefiniować kategorie, które mają być wykrywane. System przypisuje do
      opinii bowiem tylko kategorie dodane do Center AI (sam nie wykrywa dodatkowych kategorii).<br />
      - Włączyć automatyczną kategoryzację opinii dla wybranych kategorii.<br /><br />
      Obie te czynności można wykonać na ekranie do zarządzania kategoriami.`,
      manageAlerts: {
        add: `Dodałeś/aś {0} fraz.`,
        delete: `Usunąłeś/aś {0} fraz.`,
        update: `Edytowałeś/aś {0} fraz.`
      },
      alertAfterEditTitle: ``,
      alertAfterEditContent: `Wprowadziłeś/aś zmiany we frazach do kategorii “{0}”, ale nie włączyłeś/łaś automatycznej kategoryzacji. </br> <b>Czy chcesz włączyć automatyczną kategoryzację dla tej kategorii?</b>`
    },
    autCategorizationEnabled: "Kategoria została przypisana automatycznie.",
    autoCategorizationLabel:
      "Kategoria ma włączoną automatyczną kategoryzację.",
    findPhrase: "Znajdź frazę",
    removePhrases: "Usuń frazy",
    autoCategorization: "Automatyczna kategoryzacja",
    allCategories: "Wszystkich kategorii",
    allPhrases: "Wszystkich fraz",
    phraseList: "Lista fraz",
    categoryAssignTitle: "Czego dotyczą te opinie?",
    categoryAssignSubtitle:
      "Wybierz kategorie, które chcesz przypisać do wybranych opinii.",
    assignCategories: "Przypisz kategorie",
    enterNewCategory: "Wpisz nową kategorię",
    enterNewPhrase: "Wpisz nową frazę",
    reviews: "Opinie klientów",
    reviewsList: "Lista opinii",
    reviewsWith: "Opinie:",
    replyPublished: "Odpowiedź opublikowana",
    replyRejected: "Odpowiedź odrzucona",
    tip:
      "Opinie klientów - w tym miejscu zebrane są wszystkie opinie z Twoich wizytówek. Możesz udzielać odpowiedzi pojedynczo, z użyciem szablonów lub masowo oraz jeśli będzie to konieczne, to w dowolnym czasie dokonać edycji. Dokonaj kategoryzacji opinii, aby lepiej określić o czym piszą Twoi klienci. Szeroki wybór filtrów pomoże Ci odnaleźć interesujące Cię opinie. Polecamy wybrać filtr “najtrafniejsze opinie” i zobaczyć, które opinie wyświetlane są jako pierwsze w Twoich wizytówkach, postaraj się odpowiedzieć na nie w pierwszej kolejności!",
    header: "Lista opinii dla poszczególnych wizytówek",
    all: "Wszystkie",
    answered: "Z odpowiedzią",
    answer: "Odpowiedź",
    answerBtn: "Odpowiedz",
    unanswered: "Bez odpowiedzi",
    onlyComments: "Opinie z treścią",
    onlyNotes: "Opinie z notatką",
    showDeletedReviews: "Pokaż usunięte opinie",
    onlyUpdated: "Opinie edytowane w wybranym okresie",
    onlyCreated: "Opinie utworzone w wybranym okresie",
    addedToGoogle: "Dodane do Map Google",
    writtenWithAI: "Napisane z pomocą asystenta AI",
    onlyNoComments: "Opinie bez treści",
    onlyAccurate: "Najtrafniejsze opinie",
    opinions: "Opinie",
    actions: "Akcje",
    noComment: "Użytkownik dodał tylko ocenę.",
    noData:
      "W wybranym okresie nie znaleźliśmy opinii w Twoich wizytówkach. Sprawdź inny zakres dat lub poczekaj na zebranie danych.",
    totalReviewsCount: "Wszystkich opinii: {0}",
    withReplyReviewsCount: "Z odpowiedzią: {0}",
    withoutReplyReviewsCount: "Bez odpowiedzi: {0}",
    percentageOfAllReviews: "{0}% wszystkich opinii",
    yourAnswer: "Twoja odpowiedź",
    publishAnswer: "Opublikuj odpowiedź",
    reviewsAIReplyList: "Lista opinii z odpowiedziami AI",
    suggestedAnswerByAI: "Sugerowana odpowiedź przez AI",
    noSuggestedAnswerByAI:
      "W tej chwili nie ma żadnych sugerowanych odpowiedzi na opinie przez AI",
    cancel: "Anuluj",
    edit: "Edytuj",
    editAndResend: "Edytuj i wyślij ponownie",
    delete: "Usuń",
    filter: "Filtruj",
    owner: "Odpowiedź właściciela",
    city: "Miasto",
    cities: "Miasta",
    facilities: "Wizytówki",
    facilitiesGroups: "Grupy wizytówek",
    rating: "Ocena",
    save: "Zapisz",
    dateRange: "Wybierz zakres dat",
    more: "Więcej",
    addedLabel: "Dodano",
    deletedLabel: "Opinia usunięta",
    accurateLabel: "Najtrafniejsza opinia",
    accurateTooltip:
      "Najtrafniejsze opinie (komentarze) to zazwyczaj trzy wyróżnione opinie wyświetlane na głównej stronie Twojej wizytówki w Mapach Google. Klienci widzą właśnie te opinie w pierwszej kolejności.",
    search: "Szukaj wizytówek",
    searchCity: "Szukaj miasta",
    searchFacilitiesGroups: "Szukaj grup wizytówek",
    deleteReplyConfirm: "Czy na pewno chcesz usunąć odpowiedź?",
    userDataHidden: "Dane użytkownika ukryte",
    noFacilities: {
      button: "Dodaj konto",
      title: "Przeglądaj i odpowiadaj na opinie Twoich klientów",
      desc:
        "Tutaj możesz w łatwy i wygodny sposób przeglądać wszystkie opinie dotyczące Twoich wizytówek w Mapach Google oraz nawiązywać dialog z Twoimi klientami odpowiadając na te opinie. Aby było to możliwe zaimportuj Twoje wizytówki dodając konto Google."
    },
    analyst: {
      title: "Analityka ocen",
      subtitleSummary: "Podsumowanie",
      subtitleSummaryTooltip:
        "Analityka ocen - w tym miejscu możesz przeglądać oceny w  Mapach Google wystawione przez Twoich klientów.  Center AI prezentuje wszystkie oceny wystawione Twoim wizytówkom od momentu ich utworzenia. Sprawdź jak placówki były oceniane w wybranym okresie w przeszłości, a jak są oceniane obecnie, aby zrozumieć, czy jesteś na dobrej drodze. Warto udostępnić tę funkcję kierownikom regionalnym i kierownikom poszczególnych lokali, aby mogli być na bieżąco z informacjami zwrotnymi od klientów i podejmować adekwatne działania.",
      subtitleRatings: "Procentowy podział ocen",
      subtitleRatingsTooltip:
        "Rozkład wszystkich ocen dla wybranych wizytówek w wybranym okresie",
      subtitleComparison: "Porównanie",
      subtitleHistory: "Historia",
      averageRating: "Średnia ocena",
      averageRatingTooltip:
        "Średnia ocena dla wybranych wizytówek w wybranym okresie",
      totalRatingCount: "Liczba wszystkich ocen",
      totalRatingCountTooltip:
        "Liczba wszystkich ocen dla wybranych wizytówek w wybranym okresie",
      gmbAddress: "Wizytówka",
      averageRatingFromBegin: "Średnia ocena od początku",
      ratingCountFromBegin: "Liczba ocen od początku",
      newRatingCount: "Liczba ocen",
      reviews: "Oceny",
      noDataDescription:
        "Jesteśmy w trakcie zbierania danych. Pojawią się tutaj w ciągu godziny.",
      selectedPeriod: "Wybrany okres ({0})",
      comparedPeriod: "Porównywany okres ({0})",
      allReviews: "Wszystkich ocen",
      noFacilities: {
        title: "Przeglądaj dane analityczne dotyczące ocen od Twoich klientów",
        desc:
          "Tutaj możesz w łatwy sposób przeanalizować oceny dotyczące Twoich wizytówek w Mapach Google sprawdzając rozkład ocen w wybranym okresie i zobaczyć zmiany w porównaniu do poprzedniego okresu. Aby było to możliwe zaimportuj wizytówki dodając konto Google."
      },
      includedRatings: "Uwzględnione oceny",
      allRatingsIncluded:
        "Wszystkie oceny dodane lub edytowane w wybranym okresie.",
      newRatingsIncluded:
        "Tylko oceny dodane w wybranym okresie. Oceny edytowane w tym okresie nie są uwzględnione.",
      editedRatingIncluded:
        "Tylko oceny edytowane w wybranym okresie. Oceny dodane w tym okresie nie są uwzględnione."
    },
    replyTemplates: {
      title: "Szablony odpowiedzi",
      use: "Użyj",
      useTemplate: "Użyj szablonu",
      chooseTemplate: "Wybierz szablon odpowiedzi",
      replyError: "Błąd wysyłania odpowiedzi",
      categories: {
        noCategoriesDescription:
          "Chcesz szybko i sprawnie odpowiadać na opinie swoich klientów? \nDodaj kategorie i przykładowe odpowiedzi, a zwiększysz swoją efektywność.",
        [DIALOG_MANAGE_MODE.ADD]: "Dodaj kategorię",
        [DIALOG_MANAGE_MODE.EDIT]: "Edytuj kategorię",
        categoryNamePlaceholder: "Nazwa kategorii",
        category: "Nazwa kategorii",
        repliesCount: "Liczba odpowiedzi",
        createdBy: "Stworzone przez",
        viewButton: "Zobacz szablony",
        save: "Zapisz"
      },
      templates: {
        [DIALOG_MANAGE_MODE.ADD]: "Dodaj szablon",
        [DIALOG_MANAGE_MODE.EDIT]: "Edytuj szablon",
        category: "Kategoria",
        templateTextPlaceholder: "Treść odpowiedzi",
        noTemplates:
          "Nie masz jeszcze żadnych szablonów odpowiedzi w tej kategorii",
        backToList: "Wróć do listy",
        save: "Zapisz"
      }
    },

    tags: {
      changesSavedAutomatically:
        "Wszystkie wprowadzone zmiany są automatycznie zapisywane",
      activeTags: "Aktywne kategorie",
      inactiveTags: "Nieaktywne kategorie",
      tags: "Kategorie",
      manageTagsBasic: "Zarządzaj kategoriami",
      manageTags: "Zarządzaj kategoriami opinii",
      typeNewTag: "Wpisz nową kategorię",
      addedTags: "Dodane kategorie",
      noTagsDescription: "Nie masz jeszcze żadnych kategorii.",
      noTagsFilterDialogText:
        "Aktualnie nie masz dodanych żadnych kategorii. Dodaj kategorię, aby móc po nich filtrować.",
      addDescription:
        "Wpisz je w polu powyżej, kliknij enter lub “Dodaj”, aby dodać je do listy twoich kategorii.",
      selectTagsDescription:
        "Klikaj powyższe kategorie, aby dodać do wybranej opinii.",
      selectTags: "Wybierz kategorie",
      selectTag: "Wybierz kategorię",
      selected: "Wybrano",
      reviewTags: "Czego dotyczy ta opinia?",
      noTagsAssigned: "Nie przypisano żadnej kategorii",
      noTagsSelected: "Nie wybrano żadnych kategorii",
      noTagsAvailable:
        "Aby dodać kategorię do opinii musisz najpierw zdefiniować dostępne kategorie.",
      defineTagsHere: "Zdefiniuj je tutaj",
      noPermissions:
        "Nie masz uprawnień aby zdefiniować kategorie dla opinii.\nSkontaktuj się z managerem lub właścicielem konta.",
      tagDeleteAlert:
        "Czy na pewno chcesz usunąć kategorię opinii <b>{0}</b>? Jej usunięcie spowoduje, że zniknie ona ze wszystkich opinii, do których została przypisana."
    },

    bulkReply: {
      heading: "Masowe odpowiadanie",
      btnLabel: "Odpowiedz zbiorczo",
      infoBoxLabel:
        "Do każdej zaznaczonej opinii użytkowników dodamy twoją poniższą odpowiedź",
      infoBoxLabel2:
        "Opinie, które mają już odpowiedź zostaną pominięte (odpowiedzi nie zostaną zmienione).",
      bulkReplyPlaceholder: "Twoja odpowiedź",
      saveBtnLabel: "Opublikuj odpowiedź",
      replyInProgress: "Odpowiedź w trakcie wysyłania",
      replyInProgressTooltip:
        "Twoja odpowiedź jest właśnie wysyłana. Nie potrwa to długo. Aby sprawdzić czy wysyłanie zostało zakończone odśwież stronę lub wróć na nią za jakiś czas.",
      selectCustomReply: "Wpisz ręcznie",
      selectTemplateReply: "Wybierz szablony odpowiedzi",
      templateInfoBoxLabel:
        "Jeśli wybierzesz więcej niż jeden szablon, przyporządkujemy odpowiedzi losowo",
      category: "Kategoria",
      all: "Wszystkie"
    },
    sort: "Sortuj",
    ratingDesc: "Ocena: od najwyższej",
    ratingAsc: "Ocena: od najniższej",
    createDateDesc: "Data: od najnowszych",
    createDateAsc: "Data: od najstarszych",
    categories: {
      ratingsInCategory: "Oceny w kategorii {0}",
      showOnlyAutoAssignedCategories:
        "Pokaż tylko kategorie przypisywane automatycznie",
      selectLocations: "Wybierz wizytówki",
      allLocations: "Wszystkie wizytówki",
      locationsGroup: "Grupy wizytówek",
      sentiment: "Sentyment",
      changeAnyway: "Zmień, mimo to",
      makeChange: "Wprowadź zmianę",
      sentimentChange: "Potwierdź zmianę",
      sentimentChangeAlert: `Kategoria i sentyment zostały przypisane automatycznie przez naszego asystenta AI na podstawie treści opinii. Jeżeli uważasz, że przypisanie jest niepoprawne możesz to zmienić. Czy chcesz wprowadzić zmianę?`,
      generalSentiment: "Podsumowanie sentymentu",
      sentimentRateInPeriod: `Sentyment ocen w kategorii "{0}" w wybranym okresie`,
      gridColumns: {
        categories: "Kategorie",
        averageRateInPeriod: "Średnia ocena w wybranym okresie",
        countInComparisonPeriod: "Liczba opinii w porównywanym okresie",
        reviewsCount: "Liczba opinii",
        averageRateInComparisonPeriod: "Średnia ocena w porównywanym okresie",
        averageRateFromBeginning: "Średnia ocena od początku",
        reviewsCountInPeriod: "Liczba opinii w wybranym okresie",
        rates: "Oceny",
        actions: "Akcje",
        sentiment: {
          sentimentScoreTooltip: `Wskaźnik NSS (Net Sentiment Score). NSS pozwala ocenić ogólny sentyment opinii. Przyjmuje wartość od -100 (gdy wszystkie opinie są z sentymentem negatywnym) do 100 (gdy wszystkie opinie są z senymentem pozytywnym). NSS obliczany jest według wzoru: “procent opinii z sentymentem pozytywnym” - “procent opinii z sentymentem negatywnym”.`,
          positive: "Sentyment pozytywny",
          negative: "Sentyment negatywny",
          neutral: "Sentyment neutralny",
          unassigned: "Sentyment nieprzypisany",
          sentimentInSelectedPeriod: "Sentyment w wybranym okresie",
          sentimentInComparisonPeriod: "Sentyment w porównywanym okresie",
          sentimentFromBeginning: "Sentyment od początku"
        }
      },
      citySearchPlaceholder: "Jakiego miasta szukasz?",
      groupSearchPlaceholder: "Jakiej grupy wizytówek szukasz?",
      facilitySearchPlaceholder: "Jakiej wizytówki szukasz?",
      title: "Analityka kategorii opinii",
      dataFor: "Dane dla",
      allFacilities: "Wszystkie wizytówki",
      selectFacilities: "Wybierz wizytówki",
      selectedRange: "W wybranym okresie",
      fromBegin: "Od początku",
      inGivenPeriod: "W porównywanym okresie",
      selectedPeriod: "Wybrany okres",
      period: "Okres",
      comparedPeriod: "Porównywany okres",
      averageRate: "Średnia ocen",
      averageRateTooltip: "Średnia ocena",
      noName: "Brak nazwy",
      reviewsCount: "Liczba opinii",
      ratings: "Oceny",
      positive: "Pozytywnych",
      negative: "Negatywnych",
      chartDescription: `Poniższa mapa ciepła obrazuje oceny klientów w zależności od tematu,
      który poruszają oraz liczby wystawionych opinii. Im większy
      prostokąt, tym więcej opinii na dany temat. Kolor wskazuje natomiast
      na jakość opinii, zgodnie z legendą poniżej (od najlepszej
      ciemnozielonej do najgorszej ciemnoczerwonej).`,
      compare: "Porównaj",
      comparedTo: "w porównaniu do",
      categorySearchLabel: "Jakiej kategorii szukasz?",
      sentimentRateHigherTooltip: `Sentyment w wybranym okresie poprawił się względem
      sentymentu od początku.`,
      sentimentRateComparisonHigherTooltip: `Sentyment w wybranym okresie poprawił się względem
      sentymentu w porównywanym okresie.`,
      averageRateHigherTooltip: `Średnia ocena w wybranym okresie poprawiła się względem
średniej oceny od początku.`,
      countRateHigherTooltip: `Liczba ocen w wybranym okresie poprawiła się względem
liczby ocen w porównywanym okresie.`,
      averageRateLowerTooltip: `Średnia ocena w wybranym okresie pogorszyła się względem średniej oceny od początku.`,
      sentimentRateLowerTooltip: `Sentyment w wybranym okresie pogorszył się względem sentymentu od początku.`,
      sentimentRateComparisonLowerTooltip: `Sentyment w wybranym okresie pogorszył się względem sentymentu w porównywanym okresie.`,
      countRateLowerTooltip: `Liczba ocen w wybranym okresie pogorszyła się względem liczby ocen w porównywanym okresie.`,
      ratesInPeriodTitle: "Oceny w poszczególnych kategoriach",
      facilityRatesInPeriodTitle: "Oceny w poszczególnych wizytówkach",
      facilitiesRatesInPeriodTitle: "Oceny w poszczególnych wizytówkach",
      filters: {
        yesterday: "Wczoraj",
        last7Days: "Ostatnie 7 dni",
        last30Days: "Ostatnie 30 dni",
        last90Days: "Ostatnie 90 dni",
        last180Days: "Ostatnie 180 dni",
        last365Days: "Ostatnie 365 dni",
        lastWeek: "Poprzedni tydzień",
        lastMonth: "Poprzedni miesiąc",
        lastQuarter: "Poprzedni kwartał",
        last6Months: "Poprzednie 6 miesięcy",
        lastYear: "Poprzedni rok",
        fromBeginning: "Od początku",
        previousTerm: "Wcześniejszy okres",
        previousYear: "Wcześniejszy rok"
      },
      facilityDialog: {
        title: "Wybierz wizytówkę",
        allFacilitiesTitle: `Po wybraniu tej opcji wyświetlą się dane dotyczące wszystkich wizytówek w:`,
        allFacilitiesFooter: `Użytkownik będzie miał dostęp zawsze do wszystkich wizytówek,
        również do tych, które zostaną dodane do firmy w przyszłości.`
      }
    }
  },

  permissions: {
    usersTooltip:
      "W tym miejscu możesz dodać członków zespołu i nadać im odpowiednie uprawnienia.",
    tooltip:
      "Aby zmienić wizytówkę, kliknij w listę rozwijaną powyżej i wybierz inną wizytówkę.",
    permissions: "Uprawnienia",
    selectedCompany: "Wybrana firma",
    addNewUser: "Dodaj nowego użytkownika",
    addUserToTeam: "Dodaj użytkownika do zespołu",
    addUser: "Dodaj użytkownika",
    team: "Zespół",
    users: "Użytkownicy",
    youAreOwner: "Jesteś właścicielem",
    youAreAdmin: "Masz pełny dostęp",
    youAreManager: "Masz ograniczony dostęp",
    email: "E-mail",
    emailAddress: "Adres e-mail",
    teamInvitation: "Zaproszenie do zespołu",
    accountType: "Typ konta",
    accountTypes: {
      [AccountType.OWNER]: "Właściciel",
      [AccountType.ADMIN]: "Pełny dostęp",
      [AccountType.MANAGER]: "Ograniczony dostęp"
    },
    managerTooltip:
      "Użytkownik z dostępem ograniczonym ma dostęp tylko do wybranych funkcji i wizytówek. Te funkcje i wizytówki zostaną określone w dalszych krokach.",
    adminTooltip:
      "Użytkownik z pełnym dostępem może korzystać ze wszystkich funkcji systemu i ma dostęp do wszystkich wizytówek. Może także dodawać i usuwać wizytówki, importować wizytówki z konta Google oraz dodawać, usuwać i zmieniać uprawnienia użytkowników.",
    invitationStatus: {
      active: "Dostęp aktywny",
      pending: "Oczekuje na akceptację"
    },
    see: "Zobacz uprawnienia",
    all: "Wszystkie wizytówki",
    resend: "Wyślij ponownie",
    noUsers:
      "Potrzebujesz pomocy w zarządzaniu wizytówkami? Nadaj uprawnienia współpracownikom!",
    invitationSent: "Zaproszenie zostało wysłane ponownie",
    accountDeleted: "Użytkownik został usunięty z zespołu",
    permissionsGranted: "Uprawnienia zostały nadane",
    access: "Dostęp",
    accessTo: "Dostęp do",
    allFacilities: "wszystkie wizytówki",
    allPermissions: "wszystkie",
    limitedPermissions: "ograniczone",
    invitationEmailInfo:
      "* na podanego maila zostało wysłane zaproszenie do zespołu",
    facilitiesInGroupTitle: "Wizytówki w grupie",
    facilitiesPermissionsTitle: "Do których wizytówek chcesz nadać dostęp?",
    editFacilitiesPermissionsTitle: "Edytuj dostęp do wizytówek",
    previewFacilitiesPermissionsTitle: "Dostęp do wizytówek",
    facilitySearchPlaceholder: "Jakiej wizytówki szukasz?",
    facilityGroupSearchPlaceholder: "Jakiej grupy szukasz?",
    facilitiesList: "Lista wizytówek",
    facilitiesGroups: "Grupy wizytówek",
    selected: "Wybrane wizytówki",
    selectedAll: "Wszystkie wizytówki",
    selectedGroups: "Wybrane grupy",
    userAccessAllTo: "Użytkownik będzie miał dostep do wszystkich wizytówek w:",
    accessAllFutureInfo:
      "* użytkownik będzie miał dostęp zawsze do wszystkich wizytówek, również do tych, które zostaną dodane do firmy w przyszłości",
    userPermissions: "Uprawnienia użytkownika",
    editUserPermissions: "Edycja uprawnień użytkownika",
    noMembers:
      "Potrzebujesz pomocy w zarządzaniu wizytówkami?\n Nadaj uprawnienia współpracownikom!",
    atLeastOneFacilityRequired: "Musisz zaznaczyć przynajmniej jedną wizytówkę",
    editAccountType: "Edytuj typ konta",
    backToPermissions: "Wróć do uprawnień",
    addCompanyAsOwner: "Dodaj nową firmę jako właściciel"
  },

  permissionsData: {
    group: {
      name: {
        basic: "Uprawnienia podstawowe",
        photos: "Zdjęcia",
        gmbEdit: "Edycja wizytówek w Mapach Google",
        externalChanges: "Zarządzanie zmianami zewnętrznymi",
        gmbPosts: "Wpisy w wizytówkach w Mapach Google",
        gmbReviews: "Opinie o wizytówkach w Mapach Google",
        gmbAnalytics: "Analityka wizytówek w Mapach Google",
        storeLocator: "Store Locator",
        questionsAndAnswers: "Pytania i odpowiedzi",
        reviewBooster: "Review Booster"
      }
    },
    name: {
      viewDashboard: "Przeglądanie dashboardu",
      viewFacilitiesData: "Przeglądanie wizytówek",
      viewCompanyData: "Przeglądanie informacji o firmie",
      manageCompanyData: "Edycja informacji o firmie",
      editFacilityName: "Edycja nazwy",
      editFacilityAddress: "Edycja adresu",
      editFacilityStoreCode: "Edycja kodu sklepu",
      editFacilityWebsite: "Edycja strony www",
      editFacilityPhoneNumber: "Edycja numeru telefonu",
      editFacilityOpeningDate: "Edycja daty otwarcia",
      editFacilityDescription: "Edycja opisu",
      editFacilityAttributes: "Edycja atrybutów",
      editFacilityServiceItems: "Edycja usług",
      editFacilityPrimaryCategory: "Edycja kategorii podstawowej",
      editFacilityAdditionalCategories: "Edycja kategorii dodatkowych",
      editFacilityLabels: "Edycja etykiet",
      editFacilityHours: "Edycja godzin otwarcia",
      editFacilityOpenStatus: "Edycja stanu otwarta / zamknięta",
      editReviewReplyTemplates: "Edycja szablonów odpowiedzi",
      viewExternalChanges: "Przeglądanie zmian zewnętrznych",
      approveAndRejectExternalChanges:
        "Akceptacja i odrzucanie zmian zewnętrznych",
      viewExternalChangesHistory: "Przeglądanie historii zmian zewnętrznych",
      protectFromExternalChanges: "Zarządzanie ochroną zmian zewnętrznych",
      addAndDeletePhotos: "Dodawanie i usuwanie zdjęć",
      viewPhotos: "Przeglądanie listy zdjęć",
      viewLocalPosts: "Przeglądanie listy wpisów",
      addAndDeleteLocalPosts: "Dodawanie i usuwanie wpisów",
      viewReviewsAnalytics: "Przeglądanie analityki opinii",
      viewReviews: "Przeglądanie opinii",
      replyReviews: "Odpowiadanie na opinie",
      viewGmbInsights: "Przeglądanie analityki GMB",
      viewMapsRankings:
        "Przeglądanie pozycji własnych wizytówek w Mapach Google",
      viewMapsCompetitionRankings:
        "Przeglądanie pozycji wizytówek konkurencji w Mapach Google",
      manageCompetitionPlaces: "Zarządzanie konkurencyjnymi wizytówkami",
      manageKeywords:
        "Zarządzanie hasłami monitorowanymi w wyszukiwarce Map Google",
      manageGmbAccount:
        "Importowanie wizytówek z Menedżera Profilu Firmy Google",
      manageExternalGmbAddresses:
        "Importowanie wizytówek spoza Menedżera Profilu Firmy Google",
      viewTeam: "Wyświetlanie członków zespołu",
      manageTeam: "Zarządzanie zespołem",
      manageReviewsCategories: "Zarządzanie kategoriami opinii",
      assignReviewsCategories: "Kategoryzowanie opinii",
      manageStoreLocator: "Konfiguracja Store Locator",
      configureAiReviewReply: "Konfiguracja odpowiadania na opinie z AI",
      viewQAndA: "Przeglądanie pytań i odpowiedzi",
      addAndEditQAndA: "Dodawanie i edycja pytań i odpowiedzi",
      deleteQAndA: "Usuwanie pytań i odpowiedzi",
      viewRbReviews: "Przeglądanie odpowiedzi z formularzy",
      viewRbReviewsAnalytics: "Przeglądanie analityki odpowiedzi",
      viewRbForms: "Przeglądanie formularzy"
    },
    tooltip: {
      viewFacilitiesData:
        "Wyświetlanie listy wizytówek bez możliwości edycji danych",
      viewCompanyData:
        "Wyświetlanie informacji o firmie (na ekranie „Twoja Firma”) bez możliwości edycji danych",
      editFacilityHours:
        "Edycja standardowych i niestandardowych godzin otwarcia (np. Informacje o świętach czy niedzielach niehandlowych) oraz dodatkowych godzin (np. godzin dostawy).",
      editFacilityOpenStatus:
        "Edycja informacji o otwarciu i zamknięciu lokalizacji",
      editFacilityOpeningDate: "Edycja daty otwarcia wizytówki",
      editFacilityAttributes:
        "Edycja atrybutów wizytówki. Atrybuty to na przykład informacje o płatności kartą, wejściu dla niepełnosprawnych czy darmowym Wifi.",
      manageCompetitionPlaces:
        "Dodawanie i usuwanie wizytówek konkurencyjnych, które są obserwowane przez Center AI",
      manageKeywords:
        "Dodawanie i usuwanie haseł monitorowanych w wyszukiwarce w Mapach Google",
      manageGmbAccount:
        "Podpinanie i odpinanie z Center AI kont Google oraz możliwość importowania wizytówek z tych kont do Center AI",
      manageExternalGmbAddresses:
        "Importowanie i usuwanie z Center AI wizytówek niezwiązanych z własnymi kontami Google. Takich wizytówek nie można edytować, można je jedynie monitorować.",
      viewTeam: "Wyświetlanie członków zespołu bez możliwości edycji uprawnień",
      manageTeam:
        "Zapraszanie nowych członków do zespołu, usuwanie członków zespołu, nadawanie i zmiana uprawnień członków zespołu",
      manageCompanyData:
        "Edycja informacji o firmie (na ekranie „Twoja firma”) oraz wyświetlanie i zarządzanie pakietem Center AI (na ekranie „Ustawienia konta”)."
    }
  },

  demoService: {
    language: {
      description: "To konto jest dostępne tylko w języku polskim."
    },
    modal: {
      text:
        "To jest wersja Demo serwisu Center AI. Nie możesz dokonywać żadnych modyfikacji. Zapraszamy do bezpłatnego założenia konta w pełnej wersji Center AI i przetestowania wszystkich funkcji.",
      buttonText: "OK"
    }
  },
  meta: {
    login: {
      title: "App Center AI - logowanie",
      description:
        "Zaloguj się do panelu zarządzania wizytówkami Menedżera Profilu Firmy Google"
    },
    signUp: {
      title:
        "Wypróbuj bezpłatnie. Zarządzaj usługami w Menedżerze Profilu Firmy Google | Center AI",
      description:
        "Wypróbuj bezpłatnie możliwość zarządzania usługami Menedżera Profilu Firmy Google: analizuj dane, optymalizuj widoczność Twoich wizytówek w Mapach Google."
    }
  },
  menuLabels: {
    [Module.DASHBOARD]: "Pulpit",
    [Module.POSITION_MONITORING]: "Monitoring pozycji w Mapach Google",
    [Module.POSITION_SINGLE_LOCATION]: "Pozycja - pojedyncze wizytówki",
    [Module.POSITION_ALL_LOCATIONS]: "Pozycja - wszystkie wizytówki",
    [Module.POSITION_COMPETITION_COMPARISON]: "Porównanie z konkurencją",
    [Module.USERS_BEHAVIOR]: "Zachowania użytkowników w Google",
    [Module.ANALYTICS_COMPARISON]: "Porównaj wizytówki",
    [Module.LOCATIONS]: "Wizytówki",
    [Module.LOCATIONS_MANAGE]: "Zarządzanie wizytówkami",
    [Module.LOCATIONS_QUALITY]: "Jakość wizytówek",
    [Module.EXTERNAL_CHANGES]: "Zmiany zewnętrzne",
    [Module.EXTERNAL_CHANGES_LIST]: "Lista zmian",
    [Module.EXTERNAL_CHANGES_PROTECT]: "Ochrona przed zmianami",
    [Module.EXTERNAL_CHANGES_HISTORY]: "Historia zmian",
    [Module.PHOTOS]: "Zdjęcia",
    [Module.POSTS]: "Wpisy",
    [Module.REVIEWS]: "Opinie klientów",
    [Module.REVIEWS_LIST]: "Lista opinii",
    [Module.REVIEWS_ANALYTICS]: "Analityka ocen",
    [Module.REVIEWS_CATEGORIES_ANALYTICS]: "Analityka kategorii opinii",
    [Module.TEAM]: "Zespół",
    [Module.SETTINGS]: "Ustawienia",
    [Module.SETTINGS_COMPANY]: "Twoja firma",
    [Module.SETTINGS_KEYWORDS]: "Monitorowane hasła",
    [Module.SETTINGS_GMB_ACCOUNTS]: "Konta Google",
    [Module.SETTINGS_FACEBOOK_ACCOUNTS]: "Konta Facebook",
    [Module.SETTINGS_APPLE_ACCOUNTS]: "Konta Apple",
    [Module.SETTINGS_MAP_CONFIG]: "Konfiguracja map",
    [Module.SETTINGS_COMPETITION_LOCATIONS]: "Konkurencyjne wizytówki",
    [Module.SETTINGS_APPS_CONFIG]: "Konfiguracja aplikacji",
    [Module.STORE_LOCATOR]: "Store Locator",
    [Module.REVIEW_BOOSTER]: "Opinie z Review Booster",
    [Module.REVIEW_BOOSTER_FORM_LIST]: "Formularze",
    [Module.REVIEW_BOOSTER]: "Review Booster",
    [Module.REVIEW_BOOSTER_REVIEWS]: "Odpowiedzi z formularzy",
    [Module.QUESTIONS_AND_ANSWERS]: "Pytania i odpowiedzi"
  },
  weekDaysShort: {
    [WEEK_DAYS.Monday]: "Po",
    [WEEK_DAYS.Tuesday]: "Wt",
    [WEEK_DAYS.Wednesday]: "Śr",
    [WEEK_DAYS.Thursday]: "Cz",
    [WEEK_DAYS.Friday]: "Pt",
    [WEEK_DAYS.Saturday]: "So",
    [WEEK_DAYS.Sunday]: "Ni"
  },
  weekDays: {
    [WEEK_DAYS.Monday]: "Poniedziałek",
    [WEEK_DAYS.Tuesday]: "Wtorek",
    [WEEK_DAYS.Wednesday]: "Środa",
    [WEEK_DAYS.Thursday]: "Czwartek",
    [WEEK_DAYS.Friday]: "Piątek",
    [WEEK_DAYS.Saturday]: "Sobota",
    [WEEK_DAYS.Sunday]: "Niedziela"
  },
  openStatusTypes: {
    [OPEN_STATUS.ANY]: "Dowolny",
    [OPEN_STATUS.OPEN]: "Otwarte",
    [OPEN_STATUS.CLOSED_PERMANENTLY]: "Zamknięte na stałe",
    [OPEN_STATUS.CLOSED_TEMPORARILY]: "Tymczasowo zamknięte"
  },
  facilityStatusTypes: {
    [FACILITY_STATUS.ANY]: "Dowolny",
    [FACILITY_STATUS.IS_VERIFIED]: "Zweryfikowane",
    [FACILITY_STATUS.IS_UNVERIFIED]: "Niezweryfikowane",
    [FACILITY_STATUS.IS_DUPLICATE]: "Duplikaty",
    [FACILITY_STATUS.HAS_PENDING_VERIFICATION]: "W trakcie weryfikacji",
    [FACILITY_STATUS.IS_INACTIVE]: "Brak połączenia"
  },
  bingFacilityStatusTypes: {
    [BING_FACILITY_STATUS.ANY]: "Dowolny",
    [BING_FACILITY_STATUS.NO_CONNECTION]: "Brak połączenia",
    [BING_FACILITY_STATUS.CONNECTION_ACTIVE]: "Połączenie aktywne",
    [BING_FACILITY_STATUS.PUBLISHING_IN_PROGRESS]: "W trakcie publikacji",
    [BING_FACILITY_STATUS.PUBLISHING_FAILED]: "Publikacja informacji nieudana",
    [BING_FACILITY_STATUS.CREATION_IN_PROGRESS]: "W trakcie tworzenia"
  },
  externalChangesSources: {
    [EXTERNAL_CHANGES_SOURCE.GMB]: "Menedżer Profilu Firmy Google",
    [EXTERNAL_CHANGES_SOURCE.EXTERNAL]: "Zmiana zewnętrzna"
  },
  externalChangesTypes: {
    [EXTERNAL_CHANGES_TYPE.ADDITION]: "Dodanie",
    [EXTERNAL_CHANGES_TYPE.REMOVAL]: "Usunięcie",
    [EXTERNAL_CHANGES_TYPE.CHANGE]: "Zmiana"
  },
  externalChangesStatuses: {
    [EXTERNAL_CHANGES_STATUS.PENDING]: "Oczekuje na akceptację",
    [EXTERNAL_CHANGES_STATUS.ACCEPTED]: "Zaakceptowana",
    [EXTERNAL_CHANGES_STATUS.REJECTED]: "Odrzucona",
    [EXTERNAL_CHANGES_STATUS.DELETED_DUE_TO_GMB]: "Usunięta przez GMB",
    [EXTERNAL_CHANGES_STATUS.DELETED_DUE_TO_CENTER]: "Usunięta przez Center"
  },
  facilitiesSortingOptions: {
    [FACILITIES_SORTING_OPTION.DEFAULT]: "Domyślnie",
    [FACILITIES_SORTING_OPTION.COUNTRY]: "Kraj A-Z",
    [FACILITIES_SORTING_OPTION.CITY]: "Miasto A-Z",
    [FACILITIES_SORTING_OPTION.STORE_CODE]: "Kod sklepu"
  },
  topChartSeries: {
    [TOP_CHART_SERIE.TOP_3]: "Pozycje 1-3",
    [TOP_CHART_SERIE.TOP_10]: "Pozycje 4-10",
    [TOP_CHART_SERIE.TOP_20]: "Pozycje 11-20"
  },
  reviewsTagsSearchTypes: {
    [REVIEWS_TAGS_SEARCH_TYPE.INCLUDE_ALL_TAGS]:
      "z wszystkimi wybranymi kategoriami",
    [REVIEWS_TAGS_SEARCH_TYPE.INCLUDE_ANY_TAG]:
      "z dowolną z wybranych kategorii",
    noCategories: "bez żadnych kategorii"
  },

  gmbVerification: {
    name:
      "Po zmianie nazwy Google może poprosić o ponowne zweryfikowanie wizytówki. Aby ograniczyć wystąpienie takiej sytuacji pamiętaj: Nazwa powinna być taka sama jak nazwa twojej firmy. Nie powinno być w niej nazwy miasta, haseł marketingowych czy słów kluczowych.",
    category:
      'Po dodaniu lub edycji kategorii Google może poprosić o ponowne zweryfikowanie wizytówki. Aby ograniczyć wystąpienie takiej sytuacji pamiętaj: Kategorie określają rodzaj firmy, a nie świadczone przez nią usługi. Opisz czym jest wizytówka, zamiast wymieniać poszczególne usługi, produkty lub udogodnienia, które oferuje. Skup się na dodaniu najwęższych pasujących kategorii (np. "pizza na telefon" zamiast "restauracja z dowozem").',
    dialog: {
      title: "Uwaga",
      body:
        "Edytujesz informacje ({fields}), których zmiana może spowodować, że Google poprosi o ponowną weryfikację wizytówek.\n\nPrzeczytaj poniższe informacje, aby upewnić się, że zmiany, które wprowadzasz są zgodne z wytycznymi Google.",
      confirm: "Potwierdź, że chcesz kontynuować."
    },
    changes: {
      name: {
        label: "Nazwa",
        description:
          "Nazwa powinna być taka sama jak nazwa twojej firmy. Nie powinno być w niej nazwy miasta, haseł marketingowych czy słów kluczowych."
      },
      address: {
        label: "Adres",
        description:
          "Aby opisać lokalizację firmy, podaj dokładny i poprawny adres. Nie umieszczaj w adresie informacji, które nie są związane z fizyczną lokalizacją firmy (np. adresów URL i słów kluczowych)."
      },
      category: {
        label: "Kategorie działalności",
        description:
          'Kategorie określają rodzaj firmy, a nie świadczone przez nią usługi. Opisz czym jest wizytówka, zamiast wymieniać poszczególne usługi, produkty lub udogodnienia, które oferuje. Skup się na dodaniu najwęższych pasujących kategorii (np. "pizza na telefon" zamiast "restauracja z dowozem").'
      }
    }
  },
  questionsAndAnswers: {
    expandAnswers: "Rozwiń odpowiedzi ({0})",
    deleteItemTitle: "Czy na pewno chcesz usunąć element?",
    collapseAnswers: "Zwiń odpowiedzi",
    selectLocation: "Wybierz wizytówke",
    questionAndAnswer: "Pytanie i odpowiedź",
    title: "Lista pytań i odpowiedzi",
    sharingPubliclyOnGoogle: "Udostępniasz publicznie w Google",
    askQuestion: "Dodaj pytanie",
    publishAnswer: "Opublikuj odpowiedź",
    tabs: {
      all: "Wszystkie",
      withoutAnswer: "Bez odpowiedzi",
      withAnswer: "Z odpowiedzią"
    },
    owner: "Właściciel",
    noDataDescription: "Brak pytań i odpowiedzi spełniających wybrane kryteria."
  },
  reviewBooster: {
    additionalQuestions: "Dodatkowe pytania",
    title: "Konfiguracja Review Booster",
    changeBlocked: "Zmiana została zablokowana",
    placeholder: {
      contactText: "Więcej o Review Booster opowie Ci nasz specjalista:",

      positiveScreenList: {
        title: "Dwie ścieżki opinii - pozytywna",
        firstElement:
          "Klient otrzymuje prośbę o ocenę zakupu w danej placówce.",
        secondElement:
          "Po ocenie klient otrzymuje podziękowanie za opinie i proszony jest o wystawienie opinii w Mapach Google",
        thirdElement:
          "W ostatnim kroku klient otrzymuje podziękowanie za wystawioną ocenę."
      },
      negativeScreenList: {
        title: "Dwie ścieżki opinii - negatywna",
        firstElement:
          "Klient otrzymuje prośbę o ocenę zakupu w danej placówce.",
        secondElement:
          "Jeśli ocena jest negatywna, klient otrzymuje prośbę o wystawienie opinii.",
        thirdElement:
          "W ostatnim kroku klient otrzymuje podziękowanie za wystawioną ocenę."
      },

      list: {
        title: "Dwie ścieżki opinii - pozytywna",
        firstElement: {
          title: "Lepsze zrozumienie klientów",
          description:
            "Dzięki zbieraniu i analizowaniu opinii klientów, możesz lepiej zrozumieć ich potrzeby, a następnie tę wiedzę przełożyć na poprawę i usprawnienie doświadczeń zakupowych Twoich klientów."
        },
        secondElement: {
          title: "Poprawa ocen i opinii w Mapach Google",
          description:
            "Biorąc pod uwagę, że ponad 93% konsumentów czyta opinie online przed dokonaniem zakupu, ich poprawa ma ogromny wpływ na decyzje zakupowe, a także podzielenie się swoim doświadczeniem z innymi (pozytywnym doświadczeniem dzieli się około 47% klientów, natomiast negatywnym aż 97%!"
        },
        thirdElement: {
          title: "Wzrost ruchu i przychodów",
          description:
            "Badania pokazują, że 89% klientów chętniej ponownie dokonuje zakupu w sklepie, który udzielił odpowiedzi na ich opinię. Dane potwierdzają, że opinie mogą generować średnio 18% wzrost sprzedaży!"
        }
      },
      subtitle: "Dlaczego Local Review Booster?"
    },
    formList: {
      title: "Formularze",
      formLink: "Linki do formularza",
      description:
        "Tutaj znajduje się lista wszystkich aktywnych formularzy do zbierania feedbacku i opinii. Dla każdego z nich możesz pobrać linki dla poszczególnych lokalizacji oraz statystyki (informacje o tym jak użytkownicy korzystali z formularzy)."
    },
    reviews: {
      title: "Odpowiedzi z formularzy",
      selectForm: "Wybierz formularz",
      googleMapsClicked: "Klient przeszedł do Map Google",
      googleMapsClickedAndReviewAdded:
        "Klient przeszedł do Map Google i dodał opinię",
      aiGenerated:
        "Użytkownik skorzystał z asystenta AI do pomocy przy napisaniu opinii.",
      reviewAddedWithRb: "Opinia dodana przez Review Booster",
      noData: "Brak danych. Wybierz inny zakres dat lub zmień filtry."
    }
  },
  storeLocator: {
    general: "Ogólne",
    faqTitle: "FAQ",
    faqSubtitle: "Podgląd pytań i odpowiedzi FAQ dla danej wizytówki",
    configSubtitle: "Dodatkowe informacje do Store Locator’a",
    contactAndSectionsTitle: "Kontakt i sekcje dodatkowe",
    contactAndSectionsDescription: `Stwórz dodatkowe sekcje w Store Locator takie jak: lista linków,
          wypunktowana lista tekstów, sekcja z buttonami, sekcja z obrazkami.`,
    faqItemTitle: "FAQ",
    backToStoreLocator: "Wróć do Store Locator",
    faqItemDescription:
      "Stwórz listę pytań i odpowiedzi na najczęściej zadawane pytania przez twoich klientów.",
    faq: {
      noFaq: "Brak pytań i odpowiedzi",
      toAllLocations: "Do wszystkich wizytówek",
      toLocation: "Do wizytówki",
      faqCreatorTitle: "FAQ kreator",
      addFaqToFacilities: "Dodaj FAQ do swoich wizytówek",
      question: "Pytanie",
      answer: "Odpowiedź",
      orderInfoText:
        "Pytania w Store Locator będziemy prezentować zgodnie z poniższą kolejnością.",
      allFacilities: "Wszystkie wizytówki",
      editTitle: "Edycja",
      changeOrder: "Zmień kolejność",
      deleteAlertTitle: "Czy na pewno chcesz usunąć pytanie?"
    },
    title: "Konfiguracja Store Locator",
    saveChanges: "Zapisz zmiany",
    enableLocator: "Chcesz włączyć Store Locator?",
    contactUs: "Skontakuj się z nami!",
    placeholder: {
      title:
        "Zoptymalizuj swoją stronę internetową i zwiększ konwersję na wizyty w sklepach za pomocą lokalizatora sklepów.",
      subtitle:
        "Co zyskasz ze Store Locator zaimplementowanym na Twojej stronie?",
      implementedIn: "Zobacz przykładowy Store Locator:",
      contactText: "Więcej o Store Locator opowie Ci nasz specjalista:",
      phone: "537 340 555",
      consultantName: "Damian Kordyła",
      list: {
        firstElement: {
          title: "Poprawisz widoczność Twoich sklepów w Google",
          description:
            "Nasze rozwiązanie Store Locator jest zoptymalizowane po kątem SEO, ułatwiając Twoim klientom znalezienie Twoich sklepów w wynikach wyszukiwania. Podstrony poszczególnych sklepów będą wyświetlane częściej, a to zwiększy ruch na stronie oraz - finalnie - w samych sklepach."
        },
        secondElement: {
          title: "Zwiększysz ruch w sklepach",
          description:
            "Dzięki naszemu rozwiązaniu, podstrona każdego z Twoich sklepów zostanie wzbogacona o dodatkowe treści, takie jak zdjęcia, informacje o ofertach  i nowościach oraz najlepsze opinie i oceny klientów, poprawiając konwersję na wizyty w sklepach."
        },
        thirdElement: {
          title: "Oszczędzasz czas",
          description:
            "Ze Store Locator możesz zarządzać wizytówkami sklepów w Mapach Google oraz na własnej stronie internetowej jednocześnie, oszczędzając znaczną ilość czasu."
        },
        fourthElement: {
          title: "Prosta integracja i dopasowanie wizualne",
          description:
            "Nasze rozwiązanie zostanie dostosowane pod katem estetycznym do wyglądu twojej strony (kolorystyka, fonty, logotypy), stając się jej integralną częścią, a sama integracja techniczna jest ekstremalnie prosta i i szybka (wystarczy jedno godzina)."
        }
      }
    },
    basic: {
      title: "Ogólne",
      url: "Adres URL",
      urlText: "Nazwa linka",
      name: "Nazwa w nagłówku",
      addLogo: "Dodaj logo",
      primaryColor: "Kolor podstawowy",
      selectPrimaryColor: "Wybierz kolor podstawowy",
      favoritesIcon: "Ikona witryny"
    },
    floatingButton: {
      text: "Tekst",
      title: "Dodatkowa konfiguracja",
      subtitle: "Dodatkowy przycisk widoczny na każdym ekranie:"
    },
    facilities: {
      title: "Wizytówki",
      show: "Wyświetlaj",
      allFacilities: "Wszystkie wizytówki ({0})",
      selectedGroups: "Wybrane grupy",
      searchArea: "Obszar wyszukiwania"
    },
    reviews: {
      title: "Opinie",
      description:
        "Opinie w Store Locator wyświetlane są od najnowszych do najstarszych. Dodatkowo możesz ograniczyć opinie tylko do tych o określonych ocenach.",
      selectRatings: "Zaznacz oceny które mamy pokazywać",
      onlyWithText: "Tylko opinie z treścią"
    },
    posts: {
      title: "Wpisy",
      description: "Wpisy wyświetlane w Store Locator możesz wybrać na {0}.",
      descriptionLink: "liście wpisów"
    },
    photos: {
      title: "Zdjęcia",
      description: "Zdjęcia wyświetlane w Store Locator możesz wybrać na {0}.",
      descriptionLink: "liście zdjęć"
    },
    saveSuccess:
      "Zapisano zmiany. Będą one widoczne w Store Locator w ciągu 10 minut.",
    extraInfo: {
      pageTitle: "Store Locator",
      title: "Kontakt i sekcje dodatkowe",
      contact: "Kontakt",
      offerLink: "Link do oferty",
      sections: "Sekcje",
      sectionName: "Nazwa sekcji (opcjonalnie)",
      addNewElement: "Dodaj kolejny",
      removeElement: "Usuń ostatni wiersz",
      moveSection: "Przenieś sekcję:",
      selectSectionType: "Wybierz rodzaj sekcji",
      noSections: "Nie masz jeszcze żadnej sekcji dodatkowej",
      linkSection: {
        defaultTitle: "Sekcja linków",
        titleAdd: "Dodaj linki",
        titleEdit: "Edytuj linki",
        label: "Lista linków",
        description:
          "Nadaj nazwę linka, która będzie wyświetlała sie klientom na stronie Store Locator'a, a następnie podaj link do którego mamy przekierować.",
        columns: {
          text: "Nazwa linka",
          url: "Adres URL"
        }
      }
    }
  },
  usersBehavior: {
    lastDaysLabel: "Dlaczego nie mogę wybrać ostatnich dwóch tygodni?",
    lastDaysTooltip:
      "Google udostępnia część danych z opóźnieniem. Ze względu na to, że niekompletne dane mogłyby wprowadzać w błąd, ograniczyliśmy zakres dat jaki można wybrać (nie można wybrać ostatnich dwóch tygodni, dla których dane mogą być niepełne)."
  },
  offer: {
    showCouponInShop: "Pokaż ten kod w sklepie",
    offerValid: "Oferta ważna",
    useOnline: "Wykorzystaj online",
    terms: "Warunki korzystania z usługi"
  },
  asyncCSVExport: {
    title: "Eksportowanie pliku",
    content1: "Trwa generowanie pliku. Możesz zamknąć to okno lub poczekać.",
    content2:
      "Po zakończeniu generowania dostaniesz wiadomość e-mail z plikiem.",
    download: "Pobierz plik",
    generatingInProgress: "Generowanie pliku",
    fileGeneratingError: "Błąd podczas generowania pliku",
    closeWindow: "Zamknij okno"
  },
  notes: {
    note: "Notatka",
    addNote: "Dodaj notatkę",
    deleteNote: "Usuń notatkę",
    deleteNoteDescription: "Na pewno chcesz usunąć notatkę?",
    noteAdded: "Dodano notatkę",
    noteDeleted: "Usunięto notatkę",
    noteUpdated: "Zaktualizowano notatkę"
  },
  sentiment: {
    reviewsProcessing: "Przetwarzanie opinii",
    reviewsProcessingNumber: "Ilość opinii w trakcie przetwarzania.",
    reviewsProcessingNumber2: "Część opinii jest w trakcie przetwarzania",
    reviewsProcessingNumber3:
      "Opinia jest obecnie przetwarzana, aby przypisać do niej automatycznie kategorie wraz z sentymentem. Podczas tego procesu nie można edytować manualnie kategorii i sentymentów.",
    inProgressAlert:
      "<strong>{0} kategorii</strong> jest w trakcie przetwarzania",
    unknown: "Sentyment nieznany",
    markAsPositive: "Oznacz jako pozytywny",
    markAsNegative: "Oznacz jako negatywny",
    markAsNeutral: "Oznacz jako neutralny",
    clearSelection: "Usuń przypisanie kategorii",
    sentimentName: "Sentyment",
    positive: "Pozytywny",
    negative: "Negatywny",
    neutral: "Neutralny",
    unassigned: "Nieprzypisany",
    mixed: "Mieszany",
    heatmap: {
      legendTitle: "Sentyment w większości",
      mostly: "W większości",
      tooltipClickInfo: "Kliknij w pole, aby zobaczyć więcej"
    }
  },
  mapIntegrations: {
    noFacilities: {
      button: "Dodaj konto",
      title: "Wysyłaj informacje o lokalizacjach w wiele miejsc",
      desc:
        "Tutaj możesz w łatwy sposób włączyć integracje z różnymi mapami. Dzięki temu informacje o Twoich lokalizacjach będą do nich automatycznie wysyłane. Aby było to możliwe zaimportuj Twoje wizytówki dodając konto Google."
    },
    mapConfigurationTitle: "Konfiguracja map",
    catalog: "Katalog",
    integrationStatus: "Status integracji",
    additionalInfo: "Dodatkowe informacje",
    actions: "Akcje",
    enable: "Włącz",
    disable: "Wyłącz",
    infoText: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit.`,
    bing: {
      dialog: {
        enable: {
          title: "Włączyć integrację z Bing Maps?",
          description: `Po włączeniu integracji wybrane informacje o wszystkich Twoich
          obecnych i przyszłych lokalizacjach będą automatycznie wysyłane do
          Bing Maps. Twoje lokalizacje, których nie ma w Bing Maps zostaną tam
          utworzone (czasami może to potrwać do 10 dni i wynika to ze sposobu działania Bing Maps). Czy chcesz kontynuować?`
        },
        disable: {
          title: "Wyłączyć integrację z Bing Maps?",
          description: `Od momentu wyłączenia integracji żadne nowe zmiany wizytówek nie będą wysyłane do Bing Maps. Czy chcesz kontynuować?`
        }
      }
    }
  },
  facebook: {
    removePageAndFacilities: "Odłącz stronę i wizytówki",
    addPage: "Dodaj stronę",
    noConnectedFacebookAccount:
      "Brak podpiętego konta, zaloguj się przez Facebook aby dodać.",
    facebookAccounts: "Konta Facebook",
    loginWithFacebook: "Zaloguj się z Facebook",
    info1:
      "Aby informacje o lokalizacjach w Center AI były wysyłane do wizytówek na Facebooku należy dodać konto Facebook i wybrać strony, w ramach których znajdują się wizytówki.",
    info2:
      "Wymagane jest, aby strony na Facebooku miały odpowiednią strukturę - wszystkie wizytówki muszą być dodane jako Location Pages w ramach strony.",
    accountRemoveAlert: {
      title: "Potwierdź odłączenie konta",
      description:
        "Po odłączeniu Center AI utraci dostęp do wizytówek z tego konta.<br /> Informacje z Center AI przestaną być wysyłane do tych wizytówek."
    },
    pageRemoveAlert: {
      title: "Potwierdź odłączenie strony i jej wizytówek",
      description:
        "Po odłączeniu Center AI utraci dostęp do wizytówek z tej strony. Informacje z Center AI przestaną być wysyłane do tych wizytówek."
    },
    enableIntegrationAlert: {
      title: "Strony zostały dodane",
      description: `Integracja z Facebookiem dla wizytówek z wybranych stron została rozpoczęta. Aby zakończyć ten proces będziemy potrzebować od ciebie dodatkowych informacji. Skontaktujemy się z toba w ciągu X dni. Status procesu możesz obserwować na ekranie <b>"Konfiguracja Map"</b>.`
    },
    selectPageDialog: {
      title: "Wybierz strony z wizytówkami",
      description: ` Wybierz strony z wizytówkami, które chcesz połączyć z lokalizacjami w
      Center AI. Po ich wybraniu rozpoczniemy proces dopasowywania wizytówek
      z Facebooka do lokalizacji w Center AI.
      <br />
      <br />
      Dopasowane wizytówki będą aktualizowane informacjami z Center AI.`,
      infobox: `Ten proces może wymagać twojego
      zaangażowania. W razie potrzeby nasz dział wsparcia skontaktuje się z
      tobą. Status procesu możesz obserwować na ekranie 'Konfiguracja Map'.)`,
      confirmAndStartIntegration: "Potwierdź i rozpocznij integrację"
    },
    goToMapConfiguration: "Przejdź do konfiguracji map",
    goBackToMapConfiguration: "Wróć do konfiguracji map",
    noPagesToAdd: "Brak stron do dodania",
    completeConfiguration: "Dokończ konfigurację",
    configurationInProgress: "W trakcie konfiguracji",
    configureAlert: {
      title: "Skonfiguruj konto Facebook",
      description:
        "Aby włączyć integrację należy najpierw skonfigurować konto Facebook.",
      confirmLabel: "Skonfiguruj konto"
    }
  },
  mobile: {
    common: {
      addApp: "Dodaj aplikację",
      appConfiguration: "Konfiguracja aplikacji",
      cancel: "Anuluj",
      noApps: "Brak aplikacji",
      appDeleteAlert: {
        btnText: "Usuń",
        title: "Usuwanie aplikacji",
        description: "Czy na pewno chcesz usunąć aplikację?"
      }
    },
    googlePlay: {
      listings: {
        subtitle: {
          mainSection: "Podpięte konta Google Play"
        },
        accountRemoveAlert: {
          title: "Potwierdź odłączenie konta",
          description:
            "Po odłączeniu Center AI utraci dostęp do aplikacji powiązanych z tym kontem.<br /> Informacje z Center AI przestaną być wysyłane do tych aplikacji."
        },
        appAddForm: {
          appName: "Nazwa aplikacji",
          googlePlayUrl: "Link do Google Play"
        },
        info:
          "Aby włączyć integrację należy najpierw skonfigurować konto Google Play."
      },
      name: "Google Play"
    }
  },
  payments: {
    activeSubscriptionDescription:
      "Twoja subskrypcja jest aktywna. Zarządzaj planem lub ureguluj zaległe płatności poniżej.",
    freePlanDescription:
      "Twój bezpłatny okres próbny obejmuje pełny dostęp do wszystkich funkcji <b>planu Standard</b>. Wybierz plan, aby kontynuować po zakończeniu okresu próbnego.",
    selectPlanButton: "Wybierz plan",
    subscriptionExpiryDate: "Data ważności subskrypcji: {date}",
    vatNumberRetrievalTooltip:
      "Pobieranie informacji jest możliwe wyłącznie dla poprawnego Polskiego numeru NIP",
    limit: "Limit",
    aboveLimit: "ponad limit",
    currently: "Obecnie",
    overLimit: "Przekroczono limity",
    usageLimits: "Przekroczone limity",
    viewUsageLimits: "Zobacz limity",
    limitDescriptionNoDeletion: `Ten plan, w porównaniu do Twojego obecnego planu, ma dodatkowe ograniczenia (limity), które obecnie są przekroczone. Aby przejść na ten plan, usuń najpierw w panelu Center AI nadmiarowe obiekty, które powodują przekroczenie limitów.`,
    limitDescription: `Ten plan, w porównaniu do Twojego obecnego planu, ma dodatkowe ograniczenia (limity), które obecnie są przekroczone. Aby przejść na ten plan, usuń najpierw nadmiarowe obiekty, które powodują przekroczenie limitów. Kliknij w przekroczony limit, aby otworzyć pole rozwijane, w którym możesz usunąć nadmiarowe obiekty.`,
    limits: {
      max_facilities: "Liczba lokalizacji",
      max_maps_keywords: "Liczba monitorwanych haseł",
      max_ai_categorization_categories: "Liczba kategorii opinii",
      max_company_users: "Liczba użytkowników",
      max_listings_competitors: "Liczba wizytówek konkurencji",
      max_websites: "Maksymalna liczba stron internetowych",
      max_organic_keywords: "Maksymalna liczba organicznych słów kluczowych",
      max_search_locations: "Maksymalna liczba lokalizacji wyszukiwania",
      max_website_competitors:
        "Maksymalna liczba konkurentów stron internetowych"
    },
    changePlanHelp:
      "Jeżeli chcesz zmienić plan na inny skontaktuj się z nami wysyłając wiadomość na adres support@center.ai lub dzwoniąc na numer telefonu 537 340 555.",
    daysLeft: "Zostało {0} dni",
    freeTrialTooltip: "Przejdź do ustawień subskrypcji, aby wybrać pakiet",
    freeTrial: "Okres próbny",
    freeTrialPeriod: "darmowy okres próbny",
    freeTrialEnded: "Darmowy okres próbny zakończył się",
    freeTrialEndsIn: "Bezpłatny okres próbny kończy się: {0}",
    title: "Subskrypcja",
    orderDetails: "Wybierz plan",
    locationsQuantity: "Ilość lokalizacji",
    payByCard: "Płatność kartą",
    payByQuickPayment: "Szybkie płatności",
    totalPrice: "Cena całkowita",
    perLocation: "{0} netto za lokalizację miesięcznie",
    monthly: "Miesięcznie",
    annually: "Rocznie",
    payMonthly: "Płatność miesięczna",
    payAnnually: "Płatność roczna",
    payNow: "Zapłać teraz",
    paymentDetails: "Uzupełnij dane i potwierdź płatność",
    selectedPlan: "Wybrany plan subskrypcji",
    paymentMethod: "Metoda płatności",
    completeYourPayment: "Dokończ płatność",
    paymentSummary: "Podsumowanie płatności",
    status: {
      success: "Płatność zakończone pomyślnie.",
      pending: "Twoja płatność jest przetwarzana.",
      failed: "Płatność nie powiodła się"
    },
    startUsingCenterAi: "Przejdź do aplikacji",
    goBackToPayment: "Wróć do płatności",
    error: "Błąd podczas przetwarzania płatności",
    accept: "Akceptuję",
    paymentsRegulations: "regulamin",
    promoCode: "Kod promocyjny",
    promoCodeText: "Kod promocyjny możesz dodać w kolejnym kroku",
    invoiceData: "Uzupełnij dane do faktury",
    invoiceDataDescription:
      'Dane firmy możesz wczytać automatycznie. Wystarczy, że podasz numer NIP i naciśniesz "Pobierz dane".',
    getData: "Pobierz dane",
    net: "netto",
    vat: "VAT",
    pln: "PLN",
    planDialog: {
      title: "Już prawie gotowe!",
      description: `Otworzyliśmy stronę zarządzania subskrypcją w nowej karcie. 
    Po wprowadzeniu zmian, wróć tutaj i kliknij przycisk odświeżania, 
    aby zobaczyć zaktualizowaną subskrypcję.`
    },
    processingPayment: "Przetwarzanie płatności",
    paymentErrorDescription: `
    Nie udało się zrealizować Twojej płatności. Najczęściej jest to spodowane jednym z poniższych powodów:
<br />
<br />
    <ul>
<li>Niewystarczające środki na koncie.</li>
<li>Błąd w danych karty (np. numer, data ważności, kod CVV).</li>
<li>Problemy z autoryzacją po stronie banku.</li>
</ul>
<br />

Spróbuj ponownie lub skontaktuj się ze swoim bankiem, aby rozwiązać problem.
    `,
    paymentSuccessDescription: `Wysłaliśmy fakturę na Twój e-mail. Dla każdej płatności w przyszłości będziesz otrzymywać kolejne, a pełną historię faktur znajdziesz w sekcji 'Konto użytkownika' w panelu Center AI.`
  },
  apple: {
    apple: "Apple",
    title: "Konta Apple",
    loginWithApple: "Zaloguj się przez Apple",
    emptyState: {
      title: "Brak połączonych kont Apple Maps.",
      description:
        "Połącz swoje konto Apple Maps, aby zarządzać lokalizacjami biznesowymi w Apple Maps."
    },
    header: {
      title: "Podpięte konta"
    },
    info1:
      "Aby informacje o lokalizacjach w Center AI były wysyłane do wizytówek na Apple Maps należy dodać konto Apple.",
    configureAlert: {
      title: "Skonfiguruj konto Apple",
      description:
        "Aby włączyć integrację należy najpierw skonfigurować konto Apple.",
      confirmLabel: "Skonfiguruj konto"
    },
    enableDialog: {
      title: "Włączyć integrację z Apple Maps?",
      subtitle:
        "Konto Apple zostało poprawnie dodane. Czy chcesz włączyć teraz integrację z Apple Maps?",
      description: `Po włączeniu integracji:
        <ul>
          <li>
            Istniejące wizytówki w Apple Maps zostaną zaktualizowane
            informacjami z Center AI.
          </li>
          <li>
            Wizytówki w Apple Maps będą także automatycznie aktualizowane za
            każdym razem, gdy zmienisz dane w Center AI.
          </li>
          <li>
            <b
              >Aktualizowane będą takie dane: nazwa wizytówki, kategorie
              biznesowe, adres, współrzędne geograficzne, numery telefonów,
              standardowe godziny otwarcia, specjalne godziny otwarcia, opis,
              kod sklepu, adres www.</b
            >
          </li>
          <li>
            Jeżeli w Apple Maps nie ma niektórych wizytówek to zostaną one
            utworzone na podstawie informacji z Center AI.
          </li>
        </ul><br/>
        Integrację możesz włączyć także później. W każdej chwili możesz ją także wyłączyć.
       `
    },
    disableDialog: {
      title: "Wyłączyć integrację z Apple Maps?",
      description: `Od momentu wyłączenia integracji żadne nowe zmiany wizytówek nie będą wysyłane do Apple Maps. Czy chcesz kontynuować?`
    },
    accountRemoveAlert: {
      title: "Potwierdź odłączenie konta Apple",
      description: `Po odłączeniu konta integracja z Apple Maps zostanie wyłączona. Center AI utraci możliwość wysyłania i pobierania informacji z Apple Maps. <br />
                    Konto Apple możesz dodać ponownie później.`
    }
  }
};
